var items = {
  "block.minecraft.acacia_button": "Akazienholzknopf",
  "block.minecraft.acacia_door": "Akazienholztür",
  "block.minecraft.acacia_fence": "Akazienholzzaun",
  "block.minecraft.acacia_fence_gate": "Akazienholzzauntor",
  "block.minecraft.acacia_hanging_sign": "Akazienholzhängeschild",
  "block.minecraft.acacia_leaves": "Akazienlaub",
  "block.minecraft.acacia_log": "Akazienstamm",
  "block.minecraft.acacia_planks": "Akazienholzbretter",
  "block.minecraft.acacia_pressure_plate": "Akazienholzdruckplatte",
  "block.minecraft.acacia_sapling": "Akaziensetzling",
  "block.minecraft.acacia_shelf": "Akazienholzregal",
  "block.minecraft.acacia_sign": "Akazienholzschild",
  "block.minecraft.acacia_slab": "Akazienholzstufe",
  "block.minecraft.acacia_stairs": "Akazienholztreppe",
  "block.minecraft.acacia_trapdoor": "Akazienholzfalltür",
  "block.minecraft.acacia_wall_hanging_sign": "Akazienholzwandhängeschild",
  "block.minecraft.acacia_wall_sign": "Akazienholzwandschild",
  "block.minecraft.acacia_wood": "Akazienholz",
  "block.minecraft.activator_rail": "Aktivierungsschiene",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Zierlauch",
  "block.minecraft.amethyst_block": "Amethystblock",
  "block.minecraft.amethyst_cluster": "Amethysthaufen",
  "block.minecraft.ancient_debris": "Antiker Schrott",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstufe",
  "block.minecraft.andesite_stairs": "Andesittreppe",
  "block.minecraft.andesite_wall": "Andesitmauer",
  "block.minecraft.anvil": "Amboss",
  "block.minecraft.attached_melon_stem": "Melonenranke",
  "block.minecraft.attached_pumpkin_stem": "Kürbisranke",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlaub",
  "block.minecraft.azure_bluet": "Porzellansternchen",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambusknopf",
  "block.minecraft.bamboo_door": "Bambustür",
  "block.minecraft.bamboo_fence": "Bambuszaun",
  "block.minecraft.bamboo_fence_gate": "Bambuszauntor",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschild",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikstufe",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktreppe",
  "block.minecraft.bamboo_planks": "Bambusbretter",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplatte",
  "block.minecraft.bamboo_sapling": "Bambussprössling",
  "block.minecraft.bamboo_shelf": "Bambusregal",
  "block.minecraft.bamboo_sign": "Bambusschild",
  "block.minecraft.bamboo_slab": "Bambusstufe",
  "block.minecraft.bamboo_stairs": "Bambustreppe",
  "block.minecraft.bamboo_trapdoor": "Bambusfalltür",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschild",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschild",
  "block.minecraft.banner.base.black": "Vollständig schwarzes Feld",
  "block.minecraft.banner.base.blue": "Vollständig blaues Feld",
  "block.minecraft.banner.base.brown": "Vollständig braunes Feld",
  "block.minecraft.banner.base.cyan": "Vollständig türkises Feld",
  "block.minecraft.banner.base.gray": "Vollständig graues Feld",
  "block.minecraft.banner.base.green": "Vollständig grünes Feld",
  "block.minecraft.banner.base.light_blue": "Vollständig hellblaues Feld",
  "block.minecraft.banner.base.light_gray": "Vollständig hellgraues Feld",
  "block.minecraft.banner.base.lime": "Vollständig hellgrünes Feld",
  "block.minecraft.banner.base.magenta": "Vollständig magenta Feld",
  "block.minecraft.banner.base.orange": "Vollständig oranges Feld",
  "block.minecraft.banner.base.pink": "Vollständig rosa Feld",
  "block.minecraft.banner.base.purple": "Vollständig violettes Feld",
  "block.minecraft.banner.base.red": "Vollständig rotes Feld",
  "block.minecraft.banner.base.white": "Vollständig weißes Feld",
  "block.minecraft.banner.base.yellow": "Vollständig gelbes Feld",
  "block.minecraft.banner.border.black": "Schwarzer Bord",
  "block.minecraft.banner.border.blue": "Blauer Bord",
  "block.minecraft.banner.border.brown": "Brauner Bord",
  "block.minecraft.banner.border.cyan": "Türkiser Bord",
  "block.minecraft.banner.border.gray": "Grauer Bord",
  "block.minecraft.banner.border.green": "Grüner Bord",
  "block.minecraft.banner.border.light_blue": "Hellblauer Bord",
  "block.minecraft.banner.border.light_gray": "Hellgrauer Bord",
  "block.minecraft.banner.border.lime": "Hellgrüner Bord",
  "block.minecraft.banner.border.magenta": "Magenta Bord",
  "block.minecraft.banner.border.orange": "Oranger Bord",
  "block.minecraft.banner.border.pink": "Rosa Bord",
  "block.minecraft.banner.border.purple": "Violetter Bord",
  "block.minecraft.banner.border.red": "Roter Bord",
  "block.minecraft.banner.border.white": "Weißer Bord",
  "block.minecraft.banner.border.yellow": "Gelber Bord",
  "block.minecraft.banner.bricks.black": "Feld schwarz gemauert",
  "block.minecraft.banner.bricks.blue": "Feld blau gemauert",
  "block.minecraft.banner.bricks.brown": "Feld braun gemauert",
  "block.minecraft.banner.bricks.cyan": "Feld türkis gemauert",
  "block.minecraft.banner.bricks.gray": "Feld grau gemauert",
  "block.minecraft.banner.bricks.green": "Feld grün gemauert",
  "block.minecraft.banner.bricks.light_blue": "Feld hellblau gemauert",
  "block.minecraft.banner.bricks.light_gray": "Feld hellgrau gemauert",
  "block.minecraft.banner.bricks.lime": "Feld hellgrün gemauert",
  "block.minecraft.banner.bricks.magenta": "Feld magenta gemauert",
  "block.minecraft.banner.bricks.orange": "Feld orange gemauert",
  "block.minecraft.banner.bricks.pink": "Feld rosa gemauert",
  "block.minecraft.banner.bricks.purple": "Feld violett gemauert",
  "block.minecraft.banner.bricks.red": "Feld rot gemauert",
  "block.minecraft.banner.bricks.white": "Feld weiß gemauert",
  "block.minecraft.banner.bricks.yellow": "Feld gelb gemauert",
  "block.minecraft.banner.circle.black": "Schwarze Kugel",
  "block.minecraft.banner.circle.blue": "Blaue Kugel",
  "block.minecraft.banner.circle.brown": "Braune Kugel",
  "block.minecraft.banner.circle.cyan": "Türkise Kugel",
  "block.minecraft.banner.circle.gray": "Graue Kugel",
  "block.minecraft.banner.circle.green": "Grüne Kugel",
  "block.minecraft.banner.circle.light_blue": "Hellblaue Kugel",
  "block.minecraft.banner.circle.light_gray": "Hellgraue Kugel",
  "block.minecraft.banner.circle.lime": "Hellgrüne Kugel",
  "block.minecraft.banner.circle.magenta": "Magenta Kugel",
  "block.minecraft.banner.circle.orange": "Orange Kugel",
  "block.minecraft.banner.circle.pink": "Rosa Kugel",
  "block.minecraft.banner.circle.purple": "Violette Kugel",
  "block.minecraft.banner.circle.red": "Rote Kugel",
  "block.minecraft.banner.circle.white": "Weiße Kugel",
  "block.minecraft.banner.circle.yellow": "Gelbe Kugel",
  "block.minecraft.banner.creeper.black": "Schwarzer Creeper",
  "block.minecraft.banner.creeper.blue": "Blauer Creeper",
  "block.minecraft.banner.creeper.brown": "Brauner Creeper",
  "block.minecraft.banner.creeper.cyan": "Türkiser Creeper",
  "block.minecraft.banner.creeper.gray": "Grauer Creeper",
  "block.minecraft.banner.creeper.green": "Grüner Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblauer Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgrauer Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrüner Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Oranger Creeper",
  "block.minecraft.banner.creeper.pink": "Rosa Creeper",
  "block.minecraft.banner.creeper.purple": "Violetter Creeper",
  "block.minecraft.banner.creeper.red": "Roter Creeper",
  "block.minecraft.banner.creeper.white": "Weißer Creeper",
  "block.minecraft.banner.creeper.yellow": "Gelber Creeper",
  "block.minecraft.banner.cross.black": "Schwarzes Andreaskreuz",
  "block.minecraft.banner.cross.blue": "Blaues Andreaskreuz",
  "block.minecraft.banner.cross.brown": "Braunes Andreaskreuz",
  "block.minecraft.banner.cross.cyan": "Türkises Andreaskreuz",
  "block.minecraft.banner.cross.gray": "Graues Andreaskreuz",
  "block.minecraft.banner.cross.green": "Grünes Andreaskreuz",
  "block.minecraft.banner.cross.light_blue": "Hellblaues Andreaskreuz",
  "block.minecraft.banner.cross.light_gray": "Hellgraues Andreaskreuz",
  "block.minecraft.banner.cross.lime": "Hellgrünes Andreaskreuz",
  "block.minecraft.banner.cross.magenta": "Magenta Andreaskreuz",
  "block.minecraft.banner.cross.orange": "Oranges Andreaskreuz",
  "block.minecraft.banner.cross.pink": "Rosa Andreaskreuz",
  "block.minecraft.banner.cross.purple": "Violettes Andreaskreuz",
  "block.minecraft.banner.cross.red": "Rotes Andreaskreuz",
  "block.minecraft.banner.cross.white": "Weißes Andreaskreuz",
  "block.minecraft.banner.cross.yellow": "Gelbes Andreaskreuz",
  "block.minecraft.banner.curly_border.black": "Schwarzer Spickelbord",
  "block.minecraft.banner.curly_border.blue": "Blauer Spickelbord",
  "block.minecraft.banner.curly_border.brown": "Brauner Spickelbord",
  "block.minecraft.banner.curly_border.cyan": "Türkiser Spickelbord",
  "block.minecraft.banner.curly_border.gray": "Grauer Spickelbord",
  "block.minecraft.banner.curly_border.green": "Grüner Spickelbord",
  "block.minecraft.banner.curly_border.light_blue": "Hellblauer Spickelbord",
  "block.minecraft.banner.curly_border.light_gray": "Hellgrauer Spickelbord",
  "block.minecraft.banner.curly_border.lime": "Hellgrüner Spickelbord",
  "block.minecraft.banner.curly_border.magenta": "Magenta Spickelbord",
  "block.minecraft.banner.curly_border.orange": "Oranger Spickelbord",
  "block.minecraft.banner.curly_border.pink": "Rosa Spickelbord",
  "block.minecraft.banner.curly_border.purple": "Violetter Spickelbord",
  "block.minecraft.banner.curly_border.red": "Roter Spickelbord",
  "block.minecraft.banner.curly_border.white": "Weißer Spickelbord",
  "block.minecraft.banner.curly_border.yellow": "Gelber Spickelbord",
  "block.minecraft.banner.diagonal_left.black": "Schwarz schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.blue": "Blau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.brown": "Braun schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.cyan": "Türkis schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.gray": "Grau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.green": "Grün schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgrau schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.lime": "Hellgrün schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.orange": "Orange schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.pink": "Rosa schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.purple": "Violett schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.red": "Rot schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.white": "Weiß schräglinks geteilt",
  "block.minecraft.banner.diagonal_left.yellow": "Gelb schräglinks geteilt",
  "block.minecraft.banner.diagonal_right.black": "Schwarz schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.brown": "Braun schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.cyan": "Türkis schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.green": "Grün schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgrau schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.lime": "Hellgrün schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.orange": "Orange schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.pink": "Rosa schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.purple": "Violett schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.red": "Rot schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.white": "Weiß schrägrechts geteilt",
  "block.minecraft.banner.diagonal_right.yellow": "Gelb schrägrechts geteilt",
  "block.minecraft.banner.diagonal_up_left.black": "Schwarz schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Braun schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Türkis schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Grün schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgrau schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgrün schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Violett schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Rot schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Weiß schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gelb schrägrechts geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwarz schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Braun schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Türkis schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Grün schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgrau schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgrün schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Violett schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Rot schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Weiß schräglinks geteilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gelb schräglinks geteilt (invertiert)",
  "block.minecraft.banner.flow.black": "Schwarzer Fluss",
  "block.minecraft.banner.flow.blue": "Blauer Fluss",
  "block.minecraft.banner.flow.brown": "Brauner Fluss",
  "block.minecraft.banner.flow.cyan": "Türkiser Fluss",
  "block.minecraft.banner.flow.gray": "Grauer Fluss",
  "block.minecraft.banner.flow.green": "Grüner Fluss",
  "block.minecraft.banner.flow.light_blue": "Hellblauer Fluss",
  "block.minecraft.banner.flow.light_gray": "Hellgrauer Fluss",
  "block.minecraft.banner.flow.lime": "Hellgrüner Fluss",
  "block.minecraft.banner.flow.magenta": "Magenta Fluss",
  "block.minecraft.banner.flow.orange": "Oranger Fluss",
  "block.minecraft.banner.flow.pink": "Rosa Fluss",
  "block.minecraft.banner.flow.purple": "Violetter Fluss",
  "block.minecraft.banner.flow.red": "Roter Fluss",
  "block.minecraft.banner.flow.white": "Weißer Fluss",
  "block.minecraft.banner.flow.yellow": "Gelber Fluss",
  "block.minecraft.banner.flower.black": "Schwarze Blume",
  "block.minecraft.banner.flower.blue": "Blaue Blume",
  "block.minecraft.banner.flower.brown": "Braune Blume",
  "block.minecraft.banner.flower.cyan": "Türkise Blume",
  "block.minecraft.banner.flower.gray": "Graue Blume",
  "block.minecraft.banner.flower.green": "Grüne Blume",
  "block.minecraft.banner.flower.light_blue": "Hellblaue Blume",
  "block.minecraft.banner.flower.light_gray": "Hellgraue Blume",
  "block.minecraft.banner.flower.lime": "Hellgrüne Blume",
  "block.minecraft.banner.flower.magenta": "Magenta Blume",
  "block.minecraft.banner.flower.orange": "Orange Blume",
  "block.minecraft.banner.flower.pink": "Rosa Blume",
  "block.minecraft.banner.flower.purple": "Violette Blume",
  "block.minecraft.banner.flower.red": "Rote Blume",
  "block.minecraft.banner.flower.white": "Weiße Blume",
  "block.minecraft.banner.flower.yellow": "Gelbe Blume",
  "block.minecraft.banner.globe.black": "Schwarzer Globus",
  "block.minecraft.banner.globe.blue": "Blauer Globus",
  "block.minecraft.banner.globe.brown": "Brauner Globus",
  "block.minecraft.banner.globe.cyan": "Türkiser Globus",
  "block.minecraft.banner.globe.gray": "Grauer Globus",
  "block.minecraft.banner.globe.green": "Grüner Globus",
  "block.minecraft.banner.globe.light_blue": "Hellblauer Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgrauer Globus",
  "block.minecraft.banner.globe.lime": "Hellgrüner Globus",
  "block.minecraft.banner.globe.magenta": "Magenta Globus",
  "block.minecraft.banner.globe.orange": "Oranger Globus",
  "block.minecraft.banner.globe.pink": "Rosa Globus",
  "block.minecraft.banner.globe.purple": "Violetter Globus",
  "block.minecraft.banner.globe.red": "Roter Globus",
  "block.minecraft.banner.globe.white": "Weißer Globus",
  "block.minecraft.banner.globe.yellow": "Gelber Globus",
  "block.minecraft.banner.gradient.black": "Schwarzer Farbverlauf",
  "block.minecraft.banner.gradient.blue": "Blauer Farbverlauf",
  "block.minecraft.banner.gradient.brown": "Brauner Farbverlauf",
  "block.minecraft.banner.gradient.cyan": "Türkiser Farbverlauf",
  "block.minecraft.banner.gradient.gray": "Grauer Farbverlauf",
  "block.minecraft.banner.gradient.green": "Grüner Farbverlauf",
  "block.minecraft.banner.gradient.light_blue": "Hellblauer Farbverlauf",
  "block.minecraft.banner.gradient.light_gray": "Hellgrauer Farbverlauf",
  "block.minecraft.banner.gradient.lime": "Hellgrüner Farbverlauf",
  "block.minecraft.banner.gradient.magenta": "Magenta Farbverlauf",
  "block.minecraft.banner.gradient.orange": "Oranger Farbverlauf",
  "block.minecraft.banner.gradient.pink": "Rosa Farbverlauf",
  "block.minecraft.banner.gradient.purple": "Violetter Farbverlauf",
  "block.minecraft.banner.gradient.red": "Roter Farbverlauf",
  "block.minecraft.banner.gradient.white": "Weißer Farbverlauf",
  "block.minecraft.banner.gradient.yellow": "Gelber Farbverlauf",
  "block.minecraft.banner.gradient_up.black": "Schwarzer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blauer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Brauner Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Türkiser Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Grauer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.green": "Grüner Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblauer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgrauer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrüner Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Oranger Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Rosa Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Violetter Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.red": "Roter Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.white": "Weißer Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Gelber Farbverlauf (invertiert)",
  "block.minecraft.banner.guster.black": "Schwarzer Windstoßer",
  "block.minecraft.banner.guster.blue": "Blauer Windstoßer",
  "block.minecraft.banner.guster.brown": "Brauner Windstoßer",
  "block.minecraft.banner.guster.cyan": "Türkiser Windstoßer",
  "block.minecraft.banner.guster.gray": "Grauer Windstoßer",
  "block.minecraft.banner.guster.green": "Grüner Windstoßer",
  "block.minecraft.banner.guster.light_blue": "Hellblauer Windstoßer",
  "block.minecraft.banner.guster.light_gray": "Hellgrauer Windstoßer",
  "block.minecraft.banner.guster.lime": "Hellgrüner Windstoßer",
  "block.minecraft.banner.guster.magenta": "Magenta Windstoßer",
  "block.minecraft.banner.guster.orange": "Oranger Windstoßer",
  "block.minecraft.banner.guster.pink": "Rosa Windstoßer",
  "block.minecraft.banner.guster.purple": "Violetter Windstoßer",
  "block.minecraft.banner.guster.red": "Roter Windstoßer",
  "block.minecraft.banner.guster.white": "Weißer Windstoßer",
  "block.minecraft.banner.guster.yellow": "Gelber Windstoßer",
  "block.minecraft.banner.half_horizontal.black": "Oben schwarz geteilt",
  "block.minecraft.banner.half_horizontal.blue": "Oben blau geteilt",
  "block.minecraft.banner.half_horizontal.brown": "Oben braun geteilt",
  "block.minecraft.banner.half_horizontal.cyan": "Oben türkis geteilt",
  "block.minecraft.banner.half_horizontal.gray": "Oben grau geteilt",
  "block.minecraft.banner.half_horizontal.green": "Oben grün geteilt",
  "block.minecraft.banner.half_horizontal.light_blue": "Oben hellblau geteilt",
  "block.minecraft.banner.half_horizontal.light_gray": "Oben hellgrau geteilt",
  "block.minecraft.banner.half_horizontal.lime": "Oben hellgrün geteilt",
  "block.minecraft.banner.half_horizontal.magenta": "Oben magenta geteilt",
  "block.minecraft.banner.half_horizontal.orange": "Oben orange geteilt",
  "block.minecraft.banner.half_horizontal.pink": "Oben rosa geteilt",
  "block.minecraft.banner.half_horizontal.purple": "Oben violett geteilt",
  "block.minecraft.banner.half_horizontal.red": "Oben rot geteilt",
  "block.minecraft.banner.half_horizontal.white": "Oben weiß geteilt",
  "block.minecraft.banner.half_horizontal.yellow": "Oben gelb geteilt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Unten schwarz geteilt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Unten blau geteilt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Unten braun geteilt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Unten türkis geteilt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Unten grau geteilt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Unten grün geteilt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Unten hellblau geteilt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Unten hellgrau geteilt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Unten hellgrün geteilt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Unten magenta geteilt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Unten orange geteilt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Unten rosa geteilt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Unten violett geteilt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Unten rot geteilt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Unten weiß geteilt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Unten gelb geteilt",
  "block.minecraft.banner.half_vertical.black": "Rechts schwarz gespalten",
  "block.minecraft.banner.half_vertical.blue": "Rechts blau gespalten",
  "block.minecraft.banner.half_vertical.brown": "Rechts braun gespalten",
  "block.minecraft.banner.half_vertical.cyan": "Rechts türkis gespalten",
  "block.minecraft.banner.half_vertical.gray": "Rechts grau gespalten",
  "block.minecraft.banner.half_vertical.green": "Rechts grün gespalten",
  "block.minecraft.banner.half_vertical.light_blue": "Rechts hellblau gespalten",
  "block.minecraft.banner.half_vertical.light_gray": "Rechts hellgrau gespalten",
  "block.minecraft.banner.half_vertical.lime": "Rechts hellgrün gespalten",
  "block.minecraft.banner.half_vertical.magenta": "Rechts magenta gespalten",
  "block.minecraft.banner.half_vertical.orange": "Rechts orange gespalten",
  "block.minecraft.banner.half_vertical.pink": "Rechts rosa gespalten",
  "block.minecraft.banner.half_vertical.purple": "Rechts violett gespalten",
  "block.minecraft.banner.half_vertical.red": "Rechts rot gespalten",
  "block.minecraft.banner.half_vertical.white": "Rechts weiß gespalten",
  "block.minecraft.banner.half_vertical.yellow": "Rechts gelb gespalten",
  "block.minecraft.banner.half_vertical_right.black": "Links schwarz gespalten",
  "block.minecraft.banner.half_vertical_right.blue": "Links blau gespalten",
  "block.minecraft.banner.half_vertical_right.brown": "Links braun gespalten",
  "block.minecraft.banner.half_vertical_right.cyan": "Links türkis gespalten",
  "block.minecraft.banner.half_vertical_right.gray": "Links grau gespalten",
  "block.minecraft.banner.half_vertical_right.green": "Links grün gespalten",
  "block.minecraft.banner.half_vertical_right.light_blue": "Links hellblau gespalten",
  "block.minecraft.banner.half_vertical_right.light_gray": "Links hellgrau gespalten",
  "block.minecraft.banner.half_vertical_right.lime": "Links hellgrün gespalten",
  "block.minecraft.banner.half_vertical_right.magenta": "Links magenta gespalten",
  "block.minecraft.banner.half_vertical_right.orange": "Links orange gespalten",
  "block.minecraft.banner.half_vertical_right.pink": "Links rosa gespalten",
  "block.minecraft.banner.half_vertical_right.purple": "Links violett gespalten",
  "block.minecraft.banner.half_vertical_right.red": "Links rot gespalten",
  "block.minecraft.banner.half_vertical_right.white": "Links weiß gespalten",
  "block.minecraft.banner.half_vertical_right.yellow": "Links gelb gespalten",
  "block.minecraft.banner.mojang.black": "Schwarzes Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaues Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Braunes Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Türkises Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graues Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Grünes Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblaues Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgraues Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Hellgrünes Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Oranges Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Rosa Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Violettes Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rotes Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Weißes Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gelbes Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schwarze Schnauze",
  "block.minecraft.banner.piglin.blue": "Blaue Schnauze",
  "block.minecraft.banner.piglin.brown": "Braune Schnauze",
  "block.minecraft.banner.piglin.cyan": "Türkise Schnauze",
  "block.minecraft.banner.piglin.gray": "Graue Schnauze",
  "block.minecraft.banner.piglin.green": "Grüne Schnauze",
  "block.minecraft.banner.piglin.light_blue": "Hellblaue Schnauze",
  "block.minecraft.banner.piglin.light_gray": "Hellgraue Schnauze",
  "block.minecraft.banner.piglin.lime": "Hellgrüne Schnauze",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnauze",
  "block.minecraft.banner.piglin.orange": "Orange Schnauze",
  "block.minecraft.banner.piglin.pink": "Rosa Schnauze",
  "block.minecraft.banner.piglin.purple": "Violette Schnauze",
  "block.minecraft.banner.piglin.red": "Rote Schnauze",
  "block.minecraft.banner.piglin.white": "Weiße Schnauze",
  "block.minecraft.banner.piglin.yellow": "Gelbe Schnauze",
  "block.minecraft.banner.rhombus.black": "Schwarze Raute",
  "block.minecraft.banner.rhombus.blue": "Blaue Raute",
  "block.minecraft.banner.rhombus.brown": "Braune Raute",
  "block.minecraft.banner.rhombus.cyan": "Türkise Raute",
  "block.minecraft.banner.rhombus.gray": "Graue Raute",
  "block.minecraft.banner.rhombus.green": "Grüne Raute",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaue Raute",
  "block.minecraft.banner.rhombus.light_gray": "Hellgraue Raute",
  "block.minecraft.banner.rhombus.lime": "Hellgrüne Raute",
  "block.minecraft.banner.rhombus.magenta": "Magenta Raute",
  "block.minecraft.banner.rhombus.orange": "Orange Raute",
  "block.minecraft.banner.rhombus.pink": "Rosa Raute",
  "block.minecraft.banner.rhombus.purple": "Violette Raute",
  "block.minecraft.banner.rhombus.red": "Rote Raute",
  "block.minecraft.banner.rhombus.white": "Weiße Raute",
  "block.minecraft.banner.rhombus.yellow": "Gelbe Raute",
  "block.minecraft.banner.skull.black": "Schwarzer Schädel",
  "block.minecraft.banner.skull.blue": "Blauer Schädel",
  "block.minecraft.banner.skull.brown": "Brauner Schädel",
  "block.minecraft.banner.skull.cyan": "Türkiser Schädel",
  "block.minecraft.banner.skull.gray": "Grauer Schädel",
  "block.minecraft.banner.skull.green": "Grüner Schädel",
  "block.minecraft.banner.skull.light_blue": "Hellblauer Schädel",
  "block.minecraft.banner.skull.light_gray": "Hellgrauer Schädel",
  "block.minecraft.banner.skull.lime": "Hellgrüner Schädel",
  "block.minecraft.banner.skull.magenta": "Magenta Schädel",
  "block.minecraft.banner.skull.orange": "Oranger Schädel",
  "block.minecraft.banner.skull.pink": "Rosa Schädel",
  "block.minecraft.banner.skull.purple": "Violetter Schädel",
  "block.minecraft.banner.skull.red": "Roter Schädel",
  "block.minecraft.banner.skull.white": "Weißer Schädel",
  "block.minecraft.banner.skull.yellow": "Gelber Schädel",
  "block.minecraft.banner.small_stripes.black": "Vier schwarze Pfähle",
  "block.minecraft.banner.small_stripes.blue": "Vier blaue Pfähle",
  "block.minecraft.banner.small_stripes.brown": "Vier braune Pfähle",
  "block.minecraft.banner.small_stripes.cyan": "Vier türkise Pfähle",
  "block.minecraft.banner.small_stripes.gray": "Vier graue Pfähle",
  "block.minecraft.banner.small_stripes.green": "Vier grüne Pfähle",
  "block.minecraft.banner.small_stripes.light_blue": "Vier hellblaue Pfähle",
  "block.minecraft.banner.small_stripes.light_gray": "Vier hellgraue Pfähle",
  "block.minecraft.banner.small_stripes.lime": "Vier hellgrüne Pfähle",
  "block.minecraft.banner.small_stripes.magenta": "Vier magenta Pfähle",
  "block.minecraft.banner.small_stripes.orange": "Vier orange Pfähle",
  "block.minecraft.banner.small_stripes.pink": "Vier rosa Pfähle",
  "block.minecraft.banner.small_stripes.purple": "Vier violette Pfähle",
  "block.minecraft.banner.small_stripes.red": "Vier rote Pfähle",
  "block.minecraft.banner.small_stripes.white": "Vier weiße Pfähle",
  "block.minecraft.banner.small_stripes.yellow": "Vier gelbe Pfähle",
  "block.minecraft.banner.square_bottom_left.black": "Schwarzes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.blue": "Blaues rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.brown": "Braunes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.cyan": "Türkises rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.gray": "Graues rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.green": "Grünes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblaues rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgraues rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgrünes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.orange": "Oranges rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.purple": "Violettes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.red": "Rotes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.white": "Weißes rechtes Untereck",
  "block.minecraft.banner.square_bottom_left.yellow": "Gelbes rechtes Untereck",
  "block.minecraft.banner.square_bottom_right.black": "Schwarzes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.blue": "Blaues linkes Untereck",
  "block.minecraft.banner.square_bottom_right.brown": "Braunes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.cyan": "Türkises linkes Untereck",
  "block.minecraft.banner.square_bottom_right.gray": "Graues linkes Untereck",
  "block.minecraft.banner.square_bottom_right.green": "Grünes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblaues linkes Untereck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgraues linkes Untereck",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgrünes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta linkes Untereck",
  "block.minecraft.banner.square_bottom_right.orange": "Oranges linkes Untereck",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa linkes Untereck",
  "block.minecraft.banner.square_bottom_right.purple": "Violettes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.red": "Rotes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.white": "Weißes linkes Untereck",
  "block.minecraft.banner.square_bottom_right.yellow": "Gelbes linkes Untereck",
  "block.minecraft.banner.square_top_left.black": "Schwarzes rechtes Obereck",
  "block.minecraft.banner.square_top_left.blue": "Blaues rechtes Obereck",
  "block.minecraft.banner.square_top_left.brown": "Braunes rechtes Obereck",
  "block.minecraft.banner.square_top_left.cyan": "Türkises rechtes Obereck",
  "block.minecraft.banner.square_top_left.gray": "Graues rechtes Obereck",
  "block.minecraft.banner.square_top_left.green": "Grünes rechtes Obereck",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblaues rechtes Obereck",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgraues rechtes Obereck",
  "block.minecraft.banner.square_top_left.lime": "Hellgrünes rechtes Obereck",
  "block.minecraft.banner.square_top_left.magenta": "Magenta rechtes Obereck",
  "block.minecraft.banner.square_top_left.orange": "Oranges rechtes Obereck",
  "block.minecraft.banner.square_top_left.pink": "Rosa rechtes Obereck",
  "block.minecraft.banner.square_top_left.purple": "Violettes rechtes Obereck",
  "block.minecraft.banner.square_top_left.red": "Rotes rechtes Obereck",
  "block.minecraft.banner.square_top_left.white": "Weißes rechtes Obereck",
  "block.minecraft.banner.square_top_left.yellow": "Gelbes rechtes Obereck",
  "block.minecraft.banner.square_top_right.black": "Schwarzes linkes Obereck",
  "block.minecraft.banner.square_top_right.blue": "Blaues linkes Obereck",
  "block.minecraft.banner.square_top_right.brown": "Braunes linkes Obereck",
  "block.minecraft.banner.square_top_right.cyan": "Türkises linkes Obereck",
  "block.minecraft.banner.square_top_right.gray": "Graues linkes Obereck",
  "block.minecraft.banner.square_top_right.green": "Grünes linkes Obereck",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblaues linkes Obereck",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgraues linkes Obereck",
  "block.minecraft.banner.square_top_right.lime": "Hellgrünes linkes Obereck",
  "block.minecraft.banner.square_top_right.magenta": "Magenta linkes Obereck",
  "block.minecraft.banner.square_top_right.orange": "Oranges linkes Obereck",
  "block.minecraft.banner.square_top_right.pink": "Rosa linkes Obereck",
  "block.minecraft.banner.square_top_right.purple": "Violettes linkes Obereck",
  "block.minecraft.banner.square_top_right.red": "Rotes linkes Obereck",
  "block.minecraft.banner.square_top_right.white": "Weißes linkes Obereck",
  "block.minecraft.banner.square_top_right.yellow": "Gelbes linkes Obereck",
  "block.minecraft.banner.straight_cross.black": "Schwarzes Kreuz",
  "block.minecraft.banner.straight_cross.blue": "Blaues Kreuz",
  "block.minecraft.banner.straight_cross.brown": "Braunes Kreuz",
  "block.minecraft.banner.straight_cross.cyan": "Türkises Kreuz",
  "block.minecraft.banner.straight_cross.gray": "Graues Kreuz",
  "block.minecraft.banner.straight_cross.green": "Grünes Kreuz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblaues Kreuz",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgraues Kreuz",
  "block.minecraft.banner.straight_cross.lime": "Hellgrünes Kreuz",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Kreuz",
  "block.minecraft.banner.straight_cross.orange": "Oranges Kreuz",
  "block.minecraft.banner.straight_cross.pink": "Rosa Kreuz",
  "block.minecraft.banner.straight_cross.purple": "Violettes Kreuz",
  "block.minecraft.banner.straight_cross.red": "Rotes Kreuz",
  "block.minecraft.banner.straight_cross.white": "Weißes Kreuz",
  "block.minecraft.banner.straight_cross.yellow": "Gelbes Kreuz",
  "block.minecraft.banner.stripe_bottom.black": "Schwarzer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.blue": "Blauer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.brown": "Brauner Bannerfuß",
  "block.minecraft.banner.stripe_bottom.cyan": "Türkiser Bannerfuß",
  "block.minecraft.banner.stripe_bottom.gray": "Grauer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.green": "Grüner Bannerfuß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblauer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellgrauer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrüner Bannerfuß",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Bannerfuß",
  "block.minecraft.banner.stripe_bottom.orange": "Oranger Bannerfuß",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa Bannerfuß",
  "block.minecraft.banner.stripe_bottom.purple": "Violetter Bannerfuß",
  "block.minecraft.banner.stripe_bottom.red": "Roter Bannerfuß",
  "block.minecraft.banner.stripe_bottom.white": "Weißer Bannerfuß",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelber Bannerfuß",
  "block.minecraft.banner.stripe_center.black": "Schwarzer Pfahl",
  "block.minecraft.banner.stripe_center.blue": "Blauer Pfahl",
  "block.minecraft.banner.stripe_center.brown": "Brauner Pfahl",
  "block.minecraft.banner.stripe_center.cyan": "Türkiser Pfahl",
  "block.minecraft.banner.stripe_center.gray": "Grauer Pfahl",
  "block.minecraft.banner.stripe_center.green": "Grüner Pfahl",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblauer Pfahl",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgrauer Pfahl",
  "block.minecraft.banner.stripe_center.lime": "Hellgrüner Pfahl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Pfahl",
  "block.minecraft.banner.stripe_center.orange": "Oranger Pfahl",
  "block.minecraft.banner.stripe_center.pink": "Rosa Pfahl",
  "block.minecraft.banner.stripe_center.purple": "Violetter Pfahl",
  "block.minecraft.banner.stripe_center.red": "Roter Pfahl",
  "block.minecraft.banner.stripe_center.white": "Weißer Pfahl",
  "block.minecraft.banner.stripe_center.yellow": "Gelber Pfahl",
  "block.minecraft.banner.stripe_downleft.black": "Schwarzer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.blue": "Blauer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.brown": "Brauner Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.cyan": "Türkiser Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.gray": "Grauer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.green": "Grüner Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblauer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgrauer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgrüner Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.orange": "Oranger Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.purple": "Violetter Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.red": "Roter Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.white": "Weißer Schräglinksbalken",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelber Schräglinksbalken",
  "block.minecraft.banner.stripe_downright.black": "Schwarzer Schrägbalken",
  "block.minecraft.banner.stripe_downright.blue": "Blauer Schrägbalken",
  "block.minecraft.banner.stripe_downright.brown": "Brauner Schrägbalken",
  "block.minecraft.banner.stripe_downright.cyan": "Türkiser Schrägbalken",
  "block.minecraft.banner.stripe_downright.gray": "Grauer Schrägbalken",
  "block.minecraft.banner.stripe_downright.green": "Grüner Schrägbalken",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblauer Schrägbalken",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgrauer Schrägbalken",
  "block.minecraft.banner.stripe_downright.lime": "Hellgrüner Schrägbalken",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Schrägbalken",
  "block.minecraft.banner.stripe_downright.orange": "Oranger Schrägbalken",
  "block.minecraft.banner.stripe_downright.pink": "Rosa Schrägbalken",
  "block.minecraft.banner.stripe_downright.purple": "Violetter Schrägbalken",
  "block.minecraft.banner.stripe_downright.red": "Roter Schrägbalken",
  "block.minecraft.banner.stripe_downright.white": "Weißer Schrägbalken",
  "block.minecraft.banner.stripe_downright.yellow": "Gelber Schrägbalken",
  "block.minecraft.banner.stripe_left.black": "Schwarze rechte Flanke",
  "block.minecraft.banner.stripe_left.blue": "Blaue rechte Flanke",
  "block.minecraft.banner.stripe_left.brown": "Braune rechte Flanke",
  "block.minecraft.banner.stripe_left.cyan": "Türkise rechte Flanke",
  "block.minecraft.banner.stripe_left.gray": "Graue rechte Flanke",
  "block.minecraft.banner.stripe_left.green": "Grüne rechte Flanke",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblaue rechte Flanke",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgraue rechte Flanke",
  "block.minecraft.banner.stripe_left.lime": "Hellgrüne rechte Flanke",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rechte Flanke",
  "block.minecraft.banner.stripe_left.orange": "Orange rechte Flanke",
  "block.minecraft.banner.stripe_left.pink": "Rosa rechte Flanke",
  "block.minecraft.banner.stripe_left.purple": "Violette rechte Flanke",
  "block.minecraft.banner.stripe_left.red": "Rote rechte Flanke",
  "block.minecraft.banner.stripe_left.white": "Weiße rechte Flanke",
  "block.minecraft.banner.stripe_left.yellow": "Gelbe rechte Flanke",
  "block.minecraft.banner.stripe_middle.black": "Schwarzer Balken",
  "block.minecraft.banner.stripe_middle.blue": "Blauer Balken",
  "block.minecraft.banner.stripe_middle.brown": "Brauner Balken",
  "block.minecraft.banner.stripe_middle.cyan": "Türkiser Balken",
  "block.minecraft.banner.stripe_middle.gray": "Grauer Balken",
  "block.minecraft.banner.stripe_middle.green": "Grüner Balken",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblauer Balken",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgrauer Balken",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrüner Balken",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Balken",
  "block.minecraft.banner.stripe_middle.orange": "Oranger Balken",
  "block.minecraft.banner.stripe_middle.pink": "Rosa Balken",
  "block.minecraft.banner.stripe_middle.purple": "Violetter Balken",
  "block.minecraft.banner.stripe_middle.red": "Roter Balken",
  "block.minecraft.banner.stripe_middle.white": "Weißer Balken",
  "block.minecraft.banner.stripe_middle.yellow": "Gelber Balken",
  "block.minecraft.banner.stripe_right.black": "Schwarze linke Flanke",
  "block.minecraft.banner.stripe_right.blue": "Blaue linke Flanke",
  "block.minecraft.banner.stripe_right.brown": "Braune linke Flanke",
  "block.minecraft.banner.stripe_right.cyan": "Türkise linke Flanke",
  "block.minecraft.banner.stripe_right.gray": "Graue linke Flanke",
  "block.minecraft.banner.stripe_right.green": "Grüne linke Flanke",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblaue linke Flanke",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgraue linke Flanke",
  "block.minecraft.banner.stripe_right.lime": "Hellgrüne linke Flanke",
  "block.minecraft.banner.stripe_right.magenta": "Magenta linke Flanke",
  "block.minecraft.banner.stripe_right.orange": "Orange linke Flanke",
  "block.minecraft.banner.stripe_right.pink": "Rosa linke Flanke",
  "block.minecraft.banner.stripe_right.purple": "Violette linke Flanke",
  "block.minecraft.banner.stripe_right.red": "Rote linke Flanke",
  "block.minecraft.banner.stripe_right.white": "Weiße linke Flanke",
  "block.minecraft.banner.stripe_right.yellow": "Gelbe linke Flanke",
  "block.minecraft.banner.stripe_top.black": "Schwarzes Bannerhaupt",
  "block.minecraft.banner.stripe_top.blue": "Blaues Bannerhaupt",
  "block.minecraft.banner.stripe_top.brown": "Braunes Bannerhaupt",
  "block.minecraft.banner.stripe_top.cyan": "Türkises Bannerhaupt",
  "block.minecraft.banner.stripe_top.gray": "Graues Bannerhaupt",
  "block.minecraft.banner.stripe_top.green": "Grünes Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaues Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgraues Bannerhaupt",
  "block.minecraft.banner.stripe_top.lime": "Hellgrünes Bannerhaupt",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Bannerhaupt",
  "block.minecraft.banner.stripe_top.orange": "Oranges Bannerhaupt",
  "block.minecraft.banner.stripe_top.pink": "Rosa Bannerhaupt",
  "block.minecraft.banner.stripe_top.purple": "Violettes Bannerhaupt",
  "block.minecraft.banner.stripe_top.red": "Rotes Bannerhaupt",
  "block.minecraft.banner.stripe_top.white": "Weißes Bannerhaupt",
  "block.minecraft.banner.stripe_top.yellow": "Gelbes Bannerhaupt",
  "block.minecraft.banner.triangle_bottom.black": "Schwarze halbe Spitze",
  "block.minecraft.banner.triangle_bottom.blue": "Blaue halbe Spitze",
  "block.minecraft.banner.triangle_bottom.brown": "Braune halbe Spitze",
  "block.minecraft.banner.triangle_bottom.cyan": "Türkise halbe Spitze",
  "block.minecraft.banner.triangle_bottom.gray": "Graue halbe Spitze",
  "block.minecraft.banner.triangle_bottom.green": "Grüne halbe Spitze",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblaue halbe Spitze",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgraue halbe Spitze",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgrüne halbe Spitze",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta halbe Spitze",
  "block.minecraft.banner.triangle_bottom.orange": "Orange halbe Spitze",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa halbe Spitze",
  "block.minecraft.banner.triangle_bottom.purple": "Violette halbe Spitze",
  "block.minecraft.banner.triangle_bottom.red": "Rote halbe Spitze",
  "block.minecraft.banner.triangle_bottom.white": "Weiße halbe Spitze",
  "block.minecraft.banner.triangle_bottom.yellow": "Gelbe halbe Spitze",
  "block.minecraft.banner.triangle_top.black": "Schwarze gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.blue": "Blaue gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.brown": "Braune gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.cyan": "Türkise gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.gray": "Graue gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.green": "Grüne gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblaue gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgraue gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.lime": "Hellgrüne gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.magenta": "Magenta gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.orange": "Orange gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.pink": "Rosa gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.purple": "Violette gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.red": "Rote gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.white": "Weiße gestürzte halbe Spitze",
  "block.minecraft.banner.triangle_top.yellow": "Gelbe gestürzte halbe Spitze",
  "block.minecraft.banner.triangles_bottom.black": "Schwarzer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.blue": "Blauer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.brown": "Brauner gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.cyan": "Türkiser gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.gray": "Grauer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.green": "Grüner gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblauer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgrauer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgrüner gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.orange": "Oranger gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.purple": "Violetter gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.red": "Roter gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.white": "Weißer gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_bottom.yellow": "Gelber gespickelter Bannerfuß",
  "block.minecraft.banner.triangles_top.black": "Schwarzes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.blue": "Blaues gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.brown": "Braunes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.cyan": "Türkises gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.gray": "Graues gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.green": "Grünes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaues gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgraues gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.lime": "Hellgrünes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.magenta": "Magenta gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.orange": "Oranges gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.pink": "Rosa gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.purple": "Violettes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.red": "Rotes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.white": "Weißes gespickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.yellow": "Gelbes gespickeltes Bannerhaupt",
  "block.minecraft.barrel": "Fass",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Leuchtfeuer",
  "block.minecraft.beacon.primary": "Primäre Kraft",
  "block.minecraft.beacon.secondary": "Sekundäre Kraft",
  "block.minecraft.bed.no_sleep": "Du kannst nur nachts oder während eines Gewitters schlafen",
  "block.minecraft.bed.not_safe": "Du kannst jetzt nicht schlafen, es sind Monster in der Nähe",
  "block.minecraft.bed.obstructed": "Dieses Bett ist blockiert",
  "block.minecraft.bed.occupied": "Dieses Bett ist belegt",
  "block.minecraft.bed.too_far_away": "Du kannst jetzt nicht schlafen, das Bett ist zu weit entfernt",
  "block.minecraft.bedrock": "Grundgestein",
  "block.minecraft.bee_nest": "Bienennest",
  "block.minecraft.beehive": "Bienenstock",
  "block.minecraft.beetroots": "Rote Bete",
  "block.minecraft.bell": "Glocke",
  "block.minecraft.big_dripleaf": "Großes Tropfblatt",
  "block.minecraft.big_dripleaf_stem": "Großer Tropfblattstiel",
  "block.minecraft.birch_button": "Birkenholzknopf",
  "block.minecraft.birch_door": "Birkenholztür",
  "block.minecraft.birch_fence": "Birkenholzzaun",
  "block.minecraft.birch_fence_gate": "Birkenholzzauntor",
  "block.minecraft.birch_hanging_sign": "Birkenholzhängeschild",
  "block.minecraft.birch_leaves": "Birkenlaub",
  "block.minecraft.birch_log": "Birkenstamm",
  "block.minecraft.birch_planks": "Birkenholzbretter",
  "block.minecraft.birch_pressure_plate": "Birkenholzdruckplatte",
  "block.minecraft.birch_sapling": "Birkensetzling",
  "block.minecraft.birch_shelf": "Birkenholzregal",
  "block.minecraft.birch_sign": "Birkenholzschild",
  "block.minecraft.birch_slab": "Birkenholzstufe",
  "block.minecraft.birch_stairs": "Birkenholztreppe",
  "block.minecraft.birch_trapdoor": "Birkenholzfalltür",
  "block.minecraft.birch_wall_hanging_sign": "Birkenholzwandhängeschild",
  "block.minecraft.birch_wall_sign": "Birkenholzwandschild",
  "block.minecraft.birch_wood": "Birkenholz",
  "block.minecraft.black_banner": "Schwarzes Banner",
  "block.minecraft.black_bed": "Schwarzes Bett",
  "block.minecraft.black_candle": "Schwarze Kerze",
  "block.minecraft.black_candle_cake": "Kuchen mit schwarzer Kerze",
  "block.minecraft.black_carpet": "Schwarzer Teppich",
  "block.minecraft.black_concrete": "Schwarzer Beton",
  "block.minecraft.black_concrete_powder": "Schwarzer Trockenbeton",
  "block.minecraft.black_glazed_terracotta": "Schwarze glasierte Keramik",
  "block.minecraft.black_shulker_box": "Schwarze Shulker-Kiste",
  "block.minecraft.black_stained_glass": "Schwarzes Glas",
  "block.minecraft.black_stained_glass_pane": "Schwarze Glasscheibe",
  "block.minecraft.black_terracotta": "Schwarze Keramik",
  "block.minecraft.black_wool": "Schwarze Wolle",
  "block.minecraft.blackstone": "Schwarzstein",
  "block.minecraft.blackstone_slab": "Schwarzsteinstufe",
  "block.minecraft.blackstone_stairs": "Schwarzsteintreppe",
  "block.minecraft.blackstone_wall": "Schwarzsteinmauer",
  "block.minecraft.blast_furnace": "Schmelzofen",
  "block.minecraft.blue_banner": "Blaues Banner",
  "block.minecraft.blue_bed": "Blaues Bett",
  "block.minecraft.blue_candle": "Blaue Kerze",
  "block.minecraft.blue_candle_cake": "Kuchen mit blauer Kerze",
  "block.minecraft.blue_carpet": "Blauer Teppich",
  "block.minecraft.blue_concrete": "Blauer Beton",
  "block.minecraft.blue_concrete_powder": "Blauer Trockenbeton",
  "block.minecraft.blue_glazed_terracotta": "Blaue glasierte Keramik",
  "block.minecraft.blue_ice": "Blaueis",
  "block.minecraft.blue_orchid": "Blaue Orchidee",
  "block.minecraft.blue_shulker_box": "Blaue Shulker-Kiste",
  "block.minecraft.blue_stained_glass": "Blaues Glas",
  "block.minecraft.blue_stained_glass_pane": "Blaue Glasscheibe",
  "block.minecraft.blue_terracotta": "Blaue Keramik",
  "block.minecraft.blue_wool": "Blaue Wolle",
  "block.minecraft.bone_block": "Knochenblock",
  "block.minecraft.bookshelf": "Bücherregal",
  "block.minecraft.brain_coral": "Hirnkoralle",
  "block.minecraft.brain_coral_block": "Hirnkorallenblock",
  "block.minecraft.brain_coral_fan": "Hirnkorallenfächer",
  "block.minecraft.brain_coral_wall_fan": "Hirnkorallenwandfächer",
  "block.minecraft.brewing_stand": "Braustand",
  "block.minecraft.brick_slab": "Ziegelstufe",
  "block.minecraft.brick_stairs": "Ziegeltreppe",
  "block.minecraft.brick_wall": "Ziegelsteinmauer",
  "block.minecraft.bricks": "Ziegelsteine",
  "block.minecraft.brown_banner": "Braunes Banner",
  "block.minecraft.brown_bed": "Braunes Bett",
  "block.minecraft.brown_candle": "Braune Kerze",
  "block.minecraft.brown_candle_cake": "Kuchen mit brauner Kerze",
  "block.minecraft.brown_carpet": "Brauner Teppich",
  "block.minecraft.brown_concrete": "Brauner Beton",
  "block.minecraft.brown_concrete_powder": "Brauner Trockenbeton",
  "block.minecraft.brown_glazed_terracotta": "Braune glasierte Keramik",
  "block.minecraft.brown_mushroom": "Brauner Pilz",
  "block.minecraft.brown_mushroom_block": "Brauner Pilzblock",
  "block.minecraft.brown_shulker_box": "Braune Shulker-Kiste",
  "block.minecraft.brown_stained_glass": "Braunes Glas",
  "block.minecraft.brown_stained_glass_pane": "Braune Glasscheibe",
  "block.minecraft.brown_terracotta": "Braune Keramik",
  "block.minecraft.brown_wool": "Braune Wolle",
  "block.minecraft.bubble_column": "Blasensäule",
  "block.minecraft.bubble_coral": "Blasenkoralle",
  "block.minecraft.bubble_coral_block": "Blasenkorallenblock",
  "block.minecraft.bubble_coral_fan": "Blasenkorallenfächer",
  "block.minecraft.bubble_coral_wall_fan": "Blasenkorallenwandfächer",
  "block.minecraft.budding_amethyst": "Amethystknospenblock",
  "block.minecraft.bush": "Busch",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblüte",
  "block.minecraft.cake": "Kuchen",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrierter Sculk-Sensor",
  "block.minecraft.campfire": "Lagerfeuer",
  "block.minecraft.candle": "Kerze",
  "block.minecraft.candle_cake": "Kuchen mit Kerze",
  "block.minecraft.carrots": "Karotten",
  "block.minecraft.cartography_table": "Kartentisch",
  "block.minecraft.carved_pumpkin": "Geschnitzter Kürbis",
  "block.minecraft.cauldron": "Kessel",
  "block.minecraft.cave_air": "Höhlenluft",
  "block.minecraft.cave_vines": "Höhlenranken",
  "block.minecraft.cave_vines_plant": "Höhlenrankenpflanze",
  "block.minecraft.chain": "Kette",
  "block.minecraft.chain_command_block": "Ketten-Befehlsblock",
  "block.minecraft.cherry_button": "Kirschholzknopf",
  "block.minecraft.cherry_door": "Kirschholztür",
  "block.minecraft.cherry_fence": "Kirschholzzaun",
  "block.minecraft.cherry_fence_gate": "Kirschholzzauntor",
  "block.minecraft.cherry_hanging_sign": "Kirschholzhängeschild",
  "block.minecraft.cherry_leaves": "Kirschlaub",
  "block.minecraft.cherry_log": "Kirschstamm",
  "block.minecraft.cherry_planks": "Kirschholzbretter",
  "block.minecraft.cherry_pressure_plate": "Kirschholzdruckplatte",
  "block.minecraft.cherry_sapling": "Kirschsetzling",
  "block.minecraft.cherry_shelf": "Kirschholzregal",
  "block.minecraft.cherry_sign": "Kirschholzschild",
  "block.minecraft.cherry_slab": "Kirschholzstufe",
  "block.minecraft.cherry_stairs": "Kirschholztreppe",
  "block.minecraft.cherry_trapdoor": "Kirschholzfalltür",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschholzwandhängeschild",
  "block.minecraft.cherry_wall_sign": "Kirschholzwandschild",
  "block.minecraft.cherry_wood": "Kirschholz",
  "block.minecraft.chest": "Truhe",
  "block.minecraft.chipped_anvil": "Angeschlagener Amboss",
  "block.minecraft.chiseled_bookshelf": "Gearbeitetes Bücherregal",
  "block.minecraft.chiseled_copper": "Gemeißelter Kupferblock",
  "block.minecraft.chiseled_deepslate": "Gemeißelter Tiefenschiefer",
  "block.minecraft.chiseled_nether_bricks": "Gemeißelte Netherziegel",
  "block.minecraft.chiseled_polished_blackstone": "Gemeißelter polierter Schwarzstein",
  "block.minecraft.chiseled_quartz_block": "Gemeißelter Quarzblock",
  "block.minecraft.chiseled_red_sandstone": "Gemeißelter roter Sandstein",
  "block.minecraft.chiseled_resin_bricks": "Gemeißelte Harzziegel",
  "block.minecraft.chiseled_sandstone": "Gemeißelter Sandstein",
  "block.minecraft.chiseled_stone_bricks": "Gemeißelte Steinziegel",
  "block.minecraft.chiseled_tuff": "Gemeißelter Tuffstein",
  "block.minecraft.chiseled_tuff_bricks": "Gemeißelte Tuffsteinziegel",
  "block.minecraft.chorus_flower": "Chorusblüte",
  "block.minecraft.chorus_plant": "Choruspflanze",
  "block.minecraft.clay": "Ton",
  "block.minecraft.closed_eyeblossom": "Geschlossene Augenblüte",
  "block.minecraft.coal_block": "Kohleblock",
  "block.minecraft.coal_ore": "Steinkohle",
  "block.minecraft.coarse_dirt": "Grobe Erde",
  "block.minecraft.cobbled_deepslate": "Bruchtiefenschiefer",
  "block.minecraft.cobbled_deepslate_slab": "Bruchtiefenschieferstufe",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchtiefenschiefertreppe",
  "block.minecraft.cobbled_deepslate_wall": "Bruchtiefenschiefermauer",
  "block.minecraft.cobblestone": "Bruchstein",
  "block.minecraft.cobblestone_slab": "Bruchsteinstufe",
  "block.minecraft.cobblestone_stairs": "Bruchsteintreppe",
  "block.minecraft.cobblestone_wall": "Bruchsteinmauer",
  "block.minecraft.cobweb": "Spinnennetz",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Befehlsblock",
  "block.minecraft.comparator": "Redstone-Komparator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Aquisator",
  "block.minecraft.copper_bars": "Kupfergitter",
  "block.minecraft.copper_block": "Kupferblock",
  "block.minecraft.copper_bulb": "Kupferleuchte",
  "block.minecraft.copper_chain": "Kupferkette",
  "block.minecraft.copper_chest": "Kupfertruhe",
  "block.minecraft.copper_door": "Kupfertür",
  "block.minecraft.copper_golem_statue": "Kupfergolemstatue",
  "block.minecraft.copper_grate": "Kupferrost",
  "block.minecraft.copper_lantern": "Kupferlaterne",
  "block.minecraft.copper_ore": "Kupfererz",
  "block.minecraft.copper_torch": "Kupferfackel",
  "block.minecraft.copper_trapdoor": "Kupferfalltür",
  "block.minecraft.copper_wall_torch": "Kupferwandfackel",
  "block.minecraft.cornflower": "Kornblume",
  "block.minecraft.cracked_deepslate_bricks": "Rissige Tiefenschieferziegel",
  "block.minecraft.cracked_deepslate_tiles": "Rissige Tiefenschieferfliesen",
  "block.minecraft.cracked_nether_bricks": "Rissige Netherziegel",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rissige polierte Schwarzsteinziegel",
  "block.minecraft.cracked_stone_bricks": "Rissige Steinziegel",
  "block.minecraft.crafter": "Werker",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Knarzherz",
  "block.minecraft.creeper_head": "Creeperkopf",
  "block.minecraft.creeper_wall_head": "Creeper-Wandkopf",
  "block.minecraft.crimson_button": "Karmesinknopf",
  "block.minecraft.crimson_door": "Karmesintür",
  "block.minecraft.crimson_fence": "Karmesinzaun",
  "block.minecraft.crimson_fence_gate": "Karmesinzauntor",
  "block.minecraft.crimson_fungus": "Karmesinpilz",
  "block.minecraft.crimson_hanging_sign": "Karmesinhängeschild",
  "block.minecraft.crimson_hyphae": "Karmesinhyphen",
  "block.minecraft.crimson_nylium": "Karmesin-Nezel",
  "block.minecraft.crimson_planks": "Karmesinbretter",
  "block.minecraft.crimson_pressure_plate": "Karmesindruckplatte",
  "block.minecraft.crimson_roots": "Karmesinwurzeln",
  "block.minecraft.crimson_shelf": "Karmesinregal",
  "block.minecraft.crimson_sign": "Karmesinschild",
  "block.minecraft.crimson_slab": "Karmesinstufe",
  "block.minecraft.crimson_stairs": "Karmesintreppe",
  "block.minecraft.crimson_stem": "Karmesinstiel",
  "block.minecraft.crimson_trapdoor": "Karmesinfalltür",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinwandhängeschild",
  "block.minecraft.crimson_wall_sign": "Karmesinwandschild",
  "block.minecraft.crying_obsidian": "Weinender Obsidian",
  "block.minecraft.cut_copper": "Geschnittener Kupferblock",
  "block.minecraft.cut_copper_slab": "Geschnittene Kupferstufe",
  "block.minecraft.cut_copper_stairs": "Geschnittene Kupfertreppe",
  "block.minecraft.cut_red_sandstone": "Geschnittener roter Sandstein",
  "block.minecraft.cut_red_sandstone_slab": "Geschnittene rote Sandsteinstufe",
  "block.minecraft.cut_sandstone": "Geschnittener Sandstein",
  "block.minecraft.cut_sandstone_slab": "Geschnittene Sandsteinstufe",
  "block.minecraft.cyan_banner": "Türkises Banner",
  "block.minecraft.cyan_bed": "Türkises Bett",
  "block.minecraft.cyan_candle": "Türkise Kerze",
  "block.minecraft.cyan_candle_cake": "Kuchen mit türkiser Kerze",
  "block.minecraft.cyan_carpet": "Türkiser Teppich",
  "block.minecraft.cyan_concrete": "Türkiser Beton",
  "block.minecraft.cyan_concrete_powder": "Türkiser Trockenbeton",
  "block.minecraft.cyan_glazed_terracotta": "Türkise glasierte Keramik",
  "block.minecraft.cyan_shulker_box": "Türkise Shulker-Kiste",
  "block.minecraft.cyan_stained_glass": "Türkises Glas",
  "block.minecraft.cyan_stained_glass_pane": "Türkise Glasscheibe",
  "block.minecraft.cyan_terracotta": "Türkise Keramik",
  "block.minecraft.cyan_wool": "Türkise Wolle",
  "block.minecraft.damaged_anvil": "Beschädigter Amboss",
  "block.minecraft.dandelion": "Löwenzahn",
  "block.minecraft.dark_oak_button": "Schwarzeichenholzknopf",
  "block.minecraft.dark_oak_door": "Schwarzeichenholztür",
  "block.minecraft.dark_oak_fence": "Schwarzeichenholzzaun",
  "block.minecraft.dark_oak_fence_gate": "Schwarzeichenholzzauntor",
  "block.minecraft.dark_oak_hanging_sign": "Schwarzeichenholzhängeschild",
  "block.minecraft.dark_oak_leaves": "Schwarzeichenlaub",
  "block.minecraft.dark_oak_log": "Schwarzeichenstamm",
  "block.minecraft.dark_oak_planks": "Schwarzeichenholzbretter",
  "block.minecraft.dark_oak_pressure_plate": "Schwarzeichenholzdruckplatte",
  "block.minecraft.dark_oak_sapling": "Schwarzeichensetzling",
  "block.minecraft.dark_oak_shelf": "Schwarzeichenholzregal",
  "block.minecraft.dark_oak_sign": "Schwarzeichenholzschild",
  "block.minecraft.dark_oak_slab": "Schwarzeichenholzstufe",
  "block.minecraft.dark_oak_stairs": "Schwarzeichenholztreppe",
  "block.minecraft.dark_oak_trapdoor": "Schwarzeichenholzfalltür",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwarzeichenholzwandhängeschild",
  "block.minecraft.dark_oak_wall_sign": "Schwarzeichenholzwandschild",
  "block.minecraft.dark_oak_wood": "Schwarzeichenholz",
  "block.minecraft.dark_prismarine": "Dunkler Prismarin",
  "block.minecraft.dark_prismarine_slab": "Dunkle Prismarinstufe",
  "block.minecraft.dark_prismarine_stairs": "Dunkle Prismarintreppe",
  "block.minecraft.daylight_detector": "Tageslichtsensor",
  "block.minecraft.dead_brain_coral": "Abgestorbene Hirnkoralle",
  "block.minecraft.dead_brain_coral_block": "Abgestorbener Hirnkorallenblock",
  "block.minecraft.dead_brain_coral_fan": "Abgestorbener Hirnkorallenfächer",
  "block.minecraft.dead_brain_coral_wall_fan": "Abgestorbener Hirnkorallenwandfächer",
  "block.minecraft.dead_bubble_coral": "Abgestorbene Blasenkoralle",
  "block.minecraft.dead_bubble_coral_block": "Abgestorbener Blasenkorallenblock",
  "block.minecraft.dead_bubble_coral_fan": "Abgestorbener Blasenkorallenfächer",
  "block.minecraft.dead_bubble_coral_wall_fan": "Abgestorbener Blasenkorallenwandfächer",
  "block.minecraft.dead_bush": "Toter Busch",
  "block.minecraft.dead_fire_coral": "Abgestorbene Feuerkoralle",
  "block.minecraft.dead_fire_coral_block": "Abgestorbener Feuerkorallenblock",
  "block.minecraft.dead_fire_coral_fan": "Abgestorbener Feuerkorallenfächer",
  "block.minecraft.dead_fire_coral_wall_fan": "Abgestorbener Feuerkorallenwandfächer",
  "block.minecraft.dead_horn_coral": "Abgestorbene Geweihkoralle",
  "block.minecraft.dead_horn_coral_block": "Abgestorbener Geweihkorallenblock",
  "block.minecraft.dead_horn_coral_fan": "Abgestorbener Geweihkorallenfächer",
  "block.minecraft.dead_horn_coral_wall_fan": "Abgestorbener Geweihkorallenwandfächer",
  "block.minecraft.dead_tube_coral": "Abgestorbene Orgelkoralle",
  "block.minecraft.dead_tube_coral_block": "Abgestorbener Orgelkorallenblock",
  "block.minecraft.dead_tube_coral_fan": "Abgestorbener Orgelkorallenfächer",
  "block.minecraft.dead_tube_coral_wall_fan": "Abgestorbener Orgelkorallenwandfächer",
  "block.minecraft.decorated_pot": "Verzierter Krug",
  "block.minecraft.deepslate": "Tiefenschiefer",
  "block.minecraft.deepslate_brick_slab": "Tiefenschieferziegelstufe",
  "block.minecraft.deepslate_brick_stairs": "Tiefenschieferziegeltreppe",
  "block.minecraft.deepslate_brick_wall": "Tiefenschieferziegelmauer",
  "block.minecraft.deepslate_bricks": "Tiefenschieferziegel",
  "block.minecraft.deepslate_coal_ore": "Tiefenschiefer-Steinkohle",
  "block.minecraft.deepslate_copper_ore": "Tiefenschiefer-Kupfererz",
  "block.minecraft.deepslate_diamond_ore": "Tiefenschiefer-Diamanterz",
  "block.minecraft.deepslate_emerald_ore": "Tiefenschiefer-Smaragderz",
  "block.minecraft.deepslate_gold_ore": "Tiefenschiefer-Golderz",
  "block.minecraft.deepslate_iron_ore": "Tiefenschiefer-Eisenerz",
  "block.minecraft.deepslate_lapis_ore": "Tiefenschiefer-Lapislazulierz",
  "block.minecraft.deepslate_redstone_ore": "Tiefenschiefer-Redstone-Erz",
  "block.minecraft.deepslate_tile_slab": "Tiefenschieferfliesenstufe",
  "block.minecraft.deepslate_tile_stairs": "Tiefenschieferfliesentreppe",
  "block.minecraft.deepslate_tile_wall": "Tiefenschieferfliesenmauer",
  "block.minecraft.deepslate_tiles": "Tiefenschieferfliesen",
  "block.minecraft.detector_rail": "Sensorschiene",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamanterz",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritstufe",
  "block.minecraft.diorite_stairs": "Diorittreppe",
  "block.minecraft.diorite_wall": "Dioritmauer",
  "block.minecraft.dirt": "Erde",
  "block.minecraft.dirt_path": "Trampelpfad",
  "block.minecraft.dispenser": "Werfer",
  "block.minecraft.dragon_egg": "Drachenei",
  "block.minecraft.dragon_head": "Drachenkopf",
  "block.minecraft.dragon_wall_head": "Drachen-Wandkopf",
  "block.minecraft.dried_ghast": "Ausgetrockneter Ghast",
  "block.minecraft.dried_kelp_block": "Getrockneter Seetangblock",
  "block.minecraft.dripstone_block": "Tropfsteinblock",
  "block.minecraft.dropper": "Spender",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragderz",
  "block.minecraft.enchanting_table": "Zaubertisch",
  "block.minecraft.end_gateway": "Endtransitportal",
  "block.minecraft.end_portal": "Endportal",
  "block.minecraft.end_portal_frame": "Endportalrahmen",
  "block.minecraft.end_rod": "Endstab",
  "block.minecraft.end_stone": "Endstein",
  "block.minecraft.end_stone_brick_slab": "Endsteinziegelstufe",
  "block.minecraft.end_stone_brick_stairs": "Endsteinziegeltreppe",
  "block.minecraft.end_stone_brick_wall": "Endsteinziegelmauer",
  "block.minecraft.end_stone_bricks": "Endsteinziegel",
  "block.minecraft.ender_chest": "Endertruhe",
  "block.minecraft.exposed_chiseled_copper": "Angelaufener gemeißelter Kupferblock",
  "block.minecraft.exposed_copper": "Angelaufener Kupferblock",
  "block.minecraft.exposed_copper_bars": "Angelaufenes Kupfergitter",
  "block.minecraft.exposed_copper_bulb": "Angelaufene Kupferleuchte",
  "block.minecraft.exposed_copper_chain": "Angelaufene Kupferkette",
  "block.minecraft.exposed_copper_chest": "Angelaufene Kupfertruhe",
  "block.minecraft.exposed_copper_door": "Angelaufene Kupfertür",
  "block.minecraft.exposed_copper_golem_statue": "Angelaufene Kupfergolemstatue",
  "block.minecraft.exposed_copper_grate": "Angelaufener Kupferrost",
  "block.minecraft.exposed_copper_lantern": "Angelaufene Kupferlaterne",
  "block.minecraft.exposed_copper_trapdoor": "Angelaufene Kupferfalltür",
  "block.minecraft.exposed_cut_copper": "Angelaufener geschnittener Kupferblock",
  "block.minecraft.exposed_cut_copper_slab": "Angelaufene geschnittene Kupferstufe",
  "block.minecraft.exposed_cut_copper_stairs": "Angelaufene geschnittene Kupfertreppe",
  "block.minecraft.exposed_lightning_rod": "Angelaufener Blitzableiter",
  "block.minecraft.farmland": "Ackerboden",
  "block.minecraft.fern": "Farn",
  "block.minecraft.fire": "Feuer",
  "block.minecraft.fire_coral": "Feuerkoralle",
  "block.minecraft.fire_coral_block": "Feuerkorallenblock",
  "block.minecraft.fire_coral_fan": "Feuerkorallenfächer",
  "block.minecraft.fire_coral_wall_fan": "Feuerkorallenwandfächer",
  "block.minecraft.firefly_bush": "Glühwürmchenbusch",
  "block.minecraft.fletching_table": "Bognertisch",
  "block.minecraft.flower_pot": "Blumentopf",
  "block.minecraft.flowering_azalea": "Blühende Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blühendes Azaleenlaub",
  "block.minecraft.frogspawn": "Froschlaich",
  "block.minecraft.frosted_ice": "Brüchiges Eis",
  "block.minecraft.furnace": "Ofen",
  "block.minecraft.gilded_blackstone": "Golddurchzogener Schwarzstein",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasscheibe",
  "block.minecraft.glow_lichen": "Leuchtflechte",
  "block.minecraft.glowstone": "Leuchtstein",
  "block.minecraft.gold_block": "Goldblock",
  "block.minecraft.gold_ore": "Golderz",
  "block.minecraft.golden_dandelion": "Goldener Löwenzahn",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitstufe",
  "block.minecraft.granite_stairs": "Granittreppe",
  "block.minecraft.granite_wall": "Granitmauer",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblock",
  "block.minecraft.gravel": "Kies",
  "block.minecraft.gray_banner": "Graues Banner",
  "block.minecraft.gray_bed": "Graues Bett",
  "block.minecraft.gray_candle": "Graue Kerze",
  "block.minecraft.gray_candle_cake": "Kuchen mit grauer Kerze",
  "block.minecraft.gray_carpet": "Grauer Teppich",
  "block.minecraft.gray_concrete": "Grauer Beton",
  "block.minecraft.gray_concrete_powder": "Grauer Trockenbeton",
  "block.minecraft.gray_glazed_terracotta": "Graue glasierte Keramik",
  "block.minecraft.gray_shulker_box": "Graue Shulker-Kiste",
  "block.minecraft.gray_stained_glass": "Graues Glas",
  "block.minecraft.gray_stained_glass_pane": "Graue Glasscheibe",
  "block.minecraft.gray_terracotta": "Graue Keramik",
  "block.minecraft.gray_wool": "Graue Wolle",
  "block.minecraft.green_banner": "Grünes Banner",
  "block.minecraft.green_bed": "Grünes Bett",
  "block.minecraft.green_candle": "Grüne Kerze",
  "block.minecraft.green_candle_cake": "Kuchen mit grüner Kerze",
  "block.minecraft.green_carpet": "Grüner Teppich",
  "block.minecraft.green_concrete": "Grüner Beton",
  "block.minecraft.green_concrete_powder": "Grüner Trockenbeton",
  "block.minecraft.green_glazed_terracotta": "Grüne glasierte Keramik",
  "block.minecraft.green_shulker_box": "Grüne Shulker-Kiste",
  "block.minecraft.green_stained_glass": "Grünes Glas",
  "block.minecraft.green_stained_glass_pane": "Grüne Glasscheibe",
  "block.minecraft.green_terracotta": "Grüne Keramik",
  "block.minecraft.green_wool": "Grüne Wolle",
  "block.minecraft.grindstone": "Schleifstein",
  "block.minecraft.hanging_roots": "Hängende Wurzeln",
  "block.minecraft.hay_block": "Strohballen",
  "block.minecraft.heavy_core": "Schwerer Kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwägeplatte",
  "block.minecraft.honey_block": "Honigblock",
  "block.minecraft.honeycomb_block": "Honigwabenblock",
  "block.minecraft.hopper": "Trichter",
  "block.minecraft.horn_coral": "Geweihkoralle",
  "block.minecraft.horn_coral_block": "Geweihkorallenblock",
  "block.minecraft.horn_coral_fan": "Geweihkorallenfächer",
  "block.minecraft.horn_coral_wall_fan": "Geweihkorallenwandfächer",
  "block.minecraft.ice": "Eis",
  "block.minecraft.infested_chiseled_stone_bricks": "Befallene gemeißelte Steinziegel",
  "block.minecraft.infested_cobblestone": "Befallener Bruchstein",
  "block.minecraft.infested_cracked_stone_bricks": "Befallene rissige Steinziegel",
  "block.minecraft.infested_deepslate": "Befallener Tiefenschiefer",
  "block.minecraft.infested_mossy_stone_bricks": "Befallene bemooste Steinziegel",
  "block.minecraft.infested_stone": "Befallener Stein",
  "block.minecraft.infested_stone_bricks": "Befallene Steinziegel",
  "block.minecraft.iron_bars": "Eisengitter",
  "block.minecraft.iron_block": "Eisenblock",
  "block.minecraft.iron_chain": "Eisenkette",
  "block.minecraft.iron_door": "Eisentür",
  "block.minecraft.iron_ore": "Eisenerz",
  "block.minecraft.iron_trapdoor": "Eisenfalltür",
  "block.minecraft.jack_o_lantern": "Kürbislaterne",
  "block.minecraft.jigsaw": "Verbundblock",
  "block.minecraft.jukebox": "Plattenspieler",
  "block.minecraft.jungle_button": "Tropenholzknopf",
  "block.minecraft.jungle_door": "Tropenholztür",
  "block.minecraft.jungle_fence": "Tropenholzzaun",
  "block.minecraft.jungle_fence_gate": "Tropenholzzauntor",
  "block.minecraft.jungle_hanging_sign": "Tropenholzhängeschild",
  "block.minecraft.jungle_leaves": "Tropenbaumlaub",
  "block.minecraft.jungle_log": "Tropenbaumstamm",
  "block.minecraft.jungle_planks": "Tropenholzbretter",
  "block.minecraft.jungle_pressure_plate": "Tropenholzdruckplatte",
  "block.minecraft.jungle_sapling": "Tropenbaumsetzling",
  "block.minecraft.jungle_shelf": "Tropenholzregal",
  "block.minecraft.jungle_sign": "Tropenholzschild",
  "block.minecraft.jungle_slab": "Tropenholzstufe",
  "block.minecraft.jungle_stairs": "Tropenholztreppe",
  "block.minecraft.jungle_trapdoor": "Tropenholzfalltür",
  "block.minecraft.jungle_wall_hanging_sign": "Tropenholzwandhängeschild",
  "block.minecraft.jungle_wall_sign": "Tropenholzwandschild",
  "block.minecraft.jungle_wood": "Tropenholz",
  "block.minecraft.kelp": "Seetang",
  "block.minecraft.kelp_plant": "Seetangstängel",
  "block.minecraft.ladder": "Leiter",
  "block.minecraft.lantern": "Laterne",
  "block.minecraft.lapis_block": "Lapislazuliblock",
  "block.minecraft.lapis_ore": "Lapislazulierz",
  "block.minecraft.large_amethyst_bud": "Große Amethystknospe",
  "block.minecraft.large_fern": "Großer Farn",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakessel",
  "block.minecraft.leaf_litter": "Laubhaufen",
  "block.minecraft.lectern": "Lesepult",
  "block.minecraft.lever": "Hebel",
  "block.minecraft.light": "Lichtblock",
  "block.minecraft.light_blue_banner": "Hellblaues Banner",
  "block.minecraft.light_blue_bed": "Hellblaues Bett",
  "block.minecraft.light_blue_candle": "Hellblaue Kerze",
  "block.minecraft.light_blue_candle_cake": "Kuchen mit hellblauer Kerze",
  "block.minecraft.light_blue_carpet": "Hellblauer Teppich",
  "block.minecraft.light_blue_concrete": "Hellblauer Beton",
  "block.minecraft.light_blue_concrete_powder": "Hellblauer Trockenbeton",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblaue glasierte Keramik",
  "block.minecraft.light_blue_shulker_box": "Hellblaue Shulker-Kiste",
  "block.minecraft.light_blue_stained_glass": "Hellblaues Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblaue Glasscheibe",
  "block.minecraft.light_blue_terracotta": "Hellblaue Keramik",
  "block.minecraft.light_blue_wool": "Hellblaue Wolle",
  "block.minecraft.light_gray_banner": "Hellgraues Banner",
  "block.minecraft.light_gray_bed": "Hellgraues Bett",
  "block.minecraft.light_gray_candle": "Hellgraue Kerze",
  "block.minecraft.light_gray_candle_cake": "Kuchen mit hellgrauer Kerze",
  "block.minecraft.light_gray_carpet": "Hellgrauer Teppich",
  "block.minecraft.light_gray_concrete": "Hellgrauer Beton",
  "block.minecraft.light_gray_concrete_powder": "Hellgrauer Trockenbeton",
  "block.minecraft.light_gray_glazed_terracotta": "Hellgraue glasierte Keramik",
  "block.minecraft.light_gray_shulker_box": "Hellgraue Shulker-Kiste",
  "block.minecraft.light_gray_stained_glass": "Hellgraues Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgraue Glasscheibe",
  "block.minecraft.light_gray_terracotta": "Hellgraue Keramik",
  "block.minecraft.light_gray_wool": "Hellgraue Wolle",
  "block.minecraft.light_weighted_pressure_plate": "Feinwägeplatte",
  "block.minecraft.lightning_rod": "Blitzableiter",
  "block.minecraft.lilac": "Flieder",
  "block.minecraft.lily_of_the_valley": "Maiglöckchen",
  "block.minecraft.lily_pad": "Seerosenblatt",
  "block.minecraft.lime_banner": "Hellgrünes Banner",
  "block.minecraft.lime_bed": "Hellgrünes Bett",
  "block.minecraft.lime_candle": "Hellgrüne Kerze",
  "block.minecraft.lime_candle_cake": "Kuchen mit hellgrüner Kerze",
  "block.minecraft.lime_carpet": "Hellgrüner Teppich",
  "block.minecraft.lime_concrete": "Hellgrüner Beton",
  "block.minecraft.lime_concrete_powder": "Hellgrüner Trockenbeton",
  "block.minecraft.lime_glazed_terracotta": "Hellgrüne glasierte Keramik",
  "block.minecraft.lime_shulker_box": "Hellgrüne Shulker-Kiste",
  "block.minecraft.lime_stained_glass": "Hellgrünes Glas",
  "block.minecraft.lime_stained_glass_pane": "Hellgrüne Glasscheibe",
  "block.minecraft.lime_terracotta": "Hellgrüne Keramik",
  "block.minecraft.lime_wool": "Hellgrüne Wolle",
  "block.minecraft.lodestone": "Leitstein",
  "block.minecraft.loom": "Webstuhl",
  "block.minecraft.magenta_banner": "Magenta Banner",
  "block.minecraft.magenta_bed": "Magenta Bett",
  "block.minecraft.magenta_candle": "Magenta Kerze",
  "block.minecraft.magenta_candle_cake": "Kuchen mit magenta Kerze",
  "block.minecraft.magenta_carpet": "Magenta Teppich",
  "block.minecraft.magenta_concrete": "Magenta Beton",
  "block.minecraft.magenta_concrete_powder": "Magenta Trockenbeton",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glasierte Keramik",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker-Kiste",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glasscheibe",
  "block.minecraft.magenta_terracotta": "Magenta Keramik",
  "block.minecraft.magenta_wool": "Magenta Wolle",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangrovenholzknopf",
  "block.minecraft.mangrove_door": "Mangrovenholztür",
  "block.minecraft.mangrove_fence": "Mangrovenholzzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovenholzzauntor",
  "block.minecraft.mangrove_hanging_sign": "Mangrovenholzhängeschild",
  "block.minecraft.mangrove_leaves": "Mangrovenlaub",
  "block.minecraft.mangrove_log": "Mangrovenstamm",
  "block.minecraft.mangrove_planks": "Mangrovenholzbretter",
  "block.minecraft.mangrove_pressure_plate": "Mangrovenholzdruckplatte",
  "block.minecraft.mangrove_propagule": "Mangroven-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovenwurzeln",
  "block.minecraft.mangrove_shelf": "Mangrovenholzregal",
  "block.minecraft.mangrove_sign": "Mangrovenholzschild",
  "block.minecraft.mangrove_slab": "Mangrovenholzstufe",
  "block.minecraft.mangrove_stairs": "Mangrovenholztreppe",
  "block.minecraft.mangrove_trapdoor": "Mangrovenholzfalltür",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovenholzwandhängeschild",
  "block.minecraft.mangrove_wall_sign": "Mangrovenholzwandschild",
  "block.minecraft.mangrove_wood": "Mangrovenholz",
  "block.minecraft.medium_amethyst_bud": "Mittlere Amethystknospe",
  "block.minecraft.melon": "Melone",
  "block.minecraft.melon_stem": "Melonenpflanze",
  "block.minecraft.moss_block": "Moosblock",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Bemooster Bruchstein",
  "block.minecraft.mossy_cobblestone_slab": "Bemooste Bruchsteinstufe",
  "block.minecraft.mossy_cobblestone_stairs": "Bemooste Bruchsteintreppe",
  "block.minecraft.mossy_cobblestone_wall": "Bemooste Bruchsteinmauer",
  "block.minecraft.mossy_stone_brick_slab": "Bemooste Steinziegelstufe",
  "block.minecraft.mossy_stone_brick_stairs": "Bemooste Steinziegeltreppe",
  "block.minecraft.mossy_stone_brick_wall": "Bemooste Steinziegelmauer",
  "block.minecraft.mossy_stone_bricks": "Bemooste Steinziegel",
  "block.minecraft.moving_piston": "Bewegter Block",
  "block.minecraft.mud": "Schlamm",
  "block.minecraft.mud_brick_slab": "Schlammziegelstufe",
  "block.minecraft.mud_brick_stairs": "Schlammziegeltreppe",
  "block.minecraft.mud_brick_wall": "Schlammziegelmauer",
  "block.minecraft.mud_bricks": "Schlammziegel",
  "block.minecraft.muddy_mangrove_roots": "Schlammige Mangrovenwurzeln",
  "block.minecraft.mushroom_stem": "Pilzstiel",
  "block.minecraft.mycelium": "Myzel",
  "block.minecraft.nether_brick_fence": "Netherziegelzaun",
  "block.minecraft.nether_brick_slab": "Netherziegelstufe",
  "block.minecraft.nether_brick_stairs": "Netherziegeltreppe",
  "block.minecraft.nether_brick_wall": "Netherziegelmauer",
  "block.minecraft.nether_bricks": "Netherziegel",
  "block.minecraft.nether_gold_ore": "Nethergolderz",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherquarzerz",
  "block.minecraft.nether_sprouts": "Nethersprossen",
  "block.minecraft.nether_wart": "Netherwarzen",
  "block.minecraft.nether_wart_block": "Netherwarzenblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notenblock",
  "block.minecraft.oak_button": "Eichenholzknopf",
  "block.minecraft.oak_door": "Eichenholztür",
  "block.minecraft.oak_fence": "Eichenholzzaun",
  "block.minecraft.oak_fence_gate": "Eichenholzzauntor",
  "block.minecraft.oak_hanging_sign": "Eichenholzhängeschild",
  "block.minecraft.oak_leaves": "Eichenlaub",
  "block.minecraft.oak_log": "Eichenstamm",
  "block.minecraft.oak_planks": "Eichenholzbretter",
  "block.minecraft.oak_pressure_plate": "Eichenholzdruckplatte",
  "block.minecraft.oak_sapling": "Eichensetzling",
  "block.minecraft.oak_shelf": "Eichenholzregal",
  "block.minecraft.oak_sign": "Eichenholzschild",
  "block.minecraft.oak_slab": "Eichenholzstufe",
  "block.minecraft.oak_stairs": "Eichenholztreppe",
  "block.minecraft.oak_trapdoor": "Eichenholzfalltür",
  "block.minecraft.oak_wall_hanging_sign": "Eichenholzwandhängeschild",
  "block.minecraft.oak_wall_sign": "Eichenholzwandschild",
  "block.minecraft.oak_wood": "Eichenholz",
  "block.minecraft.observer": "Beobachter",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ockernes Froschlicht",
  "block.minecraft.ominous_banner": "Unheilvolles Banner",
  "block.minecraft.open_eyeblossom": "Geöffnete Augenblüte",
  "block.minecraft.orange_banner": "Oranges Banner",
  "block.minecraft.orange_bed": "Oranges Bett",
  "block.minecraft.orange_candle": "Orange Kerze",
  "block.minecraft.orange_candle_cake": "Kuchen mit oranger Kerze",
  "block.minecraft.orange_carpet": "Oranger Teppich",
  "block.minecraft.orange_concrete": "Oranger Beton",
  "block.minecraft.orange_concrete_powder": "Oranger Trockenbeton",
  "block.minecraft.orange_glazed_terracotta": "Orange glasierte Keramik",
  "block.minecraft.orange_shulker_box": "Orange Shulker-Kiste",
  "block.minecraft.orange_stained_glass": "Oranges Glas",
  "block.minecraft.orange_stained_glass_pane": "Orange Glasscheibe",
  "block.minecraft.orange_terracotta": "Orange Keramik",
  "block.minecraft.orange_tulip": "Orange Tulpe",
  "block.minecraft.orange_wool": "Orange Wolle",
  "block.minecraft.oxeye_daisy": "Margerite",
  "block.minecraft.oxidized_chiseled_copper": "Oxidierter gemeißelter Kupferblock",
  "block.minecraft.oxidized_copper": "Oxidierter Kupferblock",
  "block.minecraft.oxidized_copper_bars": "Oxidiertes Kupfergitter",
  "block.minecraft.oxidized_copper_bulb": "Oxidierte Kupferleuchte",
  "block.minecraft.oxidized_copper_chain": "Oxidierte Kupferkette",
  "block.minecraft.oxidized_copper_chest": "Oxidierte Kupfertruhe",
  "block.minecraft.oxidized_copper_door": "Oxidierte Kupfertür",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidierte Kupfergolemstatue",
  "block.minecraft.oxidized_copper_grate": "Oxidierter Kupferrost",
  "block.minecraft.oxidized_copper_lantern": "Oxidierte Kupferlaterne",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidierte Kupferfalltür",
  "block.minecraft.oxidized_cut_copper": "Oxidierter geschnittener Kupferblock",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidierte geschnittene Kupferstufe",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidierte geschnittene Kupfertreppe",
  "block.minecraft.oxidized_lightning_rod": "Oxidierter Blitzableiter",
  "block.minecraft.packed_ice": "Packeis",
  "block.minecraft.packed_mud": "Fester Schlamm",
  "block.minecraft.pale_hanging_moss": "Hängendes Blassmoos",
  "block.minecraft.pale_moss_block": "Blassmoosblock",
  "block.minecraft.pale_moss_carpet": "Blassmoosteppich",
  "block.minecraft.pale_oak_button": "Blasseichenholzknopf",
  "block.minecraft.pale_oak_door": "Blasseichenholztür",
  "block.minecraft.pale_oak_fence": "Blasseichenholzzaun",
  "block.minecraft.pale_oak_fence_gate": "Blasseichenholzzauntor",
  "block.minecraft.pale_oak_hanging_sign": "Blasseichenholzhängeschild",
  "block.minecraft.pale_oak_leaves": "Blasseichenlaub",
  "block.minecraft.pale_oak_log": "Blasseichenstamm",
  "block.minecraft.pale_oak_planks": "Blasseichenholzbretter",
  "block.minecraft.pale_oak_pressure_plate": "Blasseichenholzdruckplatte",
  "block.minecraft.pale_oak_sapling": "Blasseichensetzling",
  "block.minecraft.pale_oak_shelf": "Blasseichenholzregal",
  "block.minecraft.pale_oak_sign": "Blasseichenholzschild",
  "block.minecraft.pale_oak_slab": "Blasseichenholzstufe",
  "block.minecraft.pale_oak_stairs": "Blasseichenholztreppe",
  "block.minecraft.pale_oak_trapdoor": "Blasseichenholzfalltür",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blasseichenholzwandhängeschild",
  "block.minecraft.pale_oak_wall_sign": "Blasseichenholzwandschild",
  "block.minecraft.pale_oak_wood": "Blasseichenholz",
  "block.minecraft.pearlescent_froglight": "Perlmutternes Froschlicht",
  "block.minecraft.peony": "Pfingstrose",
  "block.minecraft.petrified_oak_slab": "Versteinerte Eichenholzstufe",
  "block.minecraft.piglin_head": "Piglinkopf",
  "block.minecraft.piglin_wall_head": "Piglin-Wandkopf",
  "block.minecraft.pink_banner": "Rosa Banner",
  "block.minecraft.pink_bed": "Rosa Bett",
  "block.minecraft.pink_candle": "Rosa Kerze",
  "block.minecraft.pink_candle_cake": "Kuchen mit rosa Kerze",
  "block.minecraft.pink_carpet": "Rosa Teppich",
  "block.minecraft.pink_concrete": "Rosa Beton",
  "block.minecraft.pink_concrete_powder": "Rosa Trockenbeton",
  "block.minecraft.pink_glazed_terracotta": "Rosa glasierte Keramik",
  "block.minecraft.pink_petals": "Rosa Blütenblätter",
  "block.minecraft.pink_shulker_box": "Rosa Shulker-Kiste",
  "block.minecraft.pink_stained_glass": "Rosa Glas",
  "block.minecraft.pink_stained_glass_pane": "Rosa Glasscheibe",
  "block.minecraft.pink_terracotta": "Rosa Keramik",
  "block.minecraft.pink_tulip": "Rosa Tulpe",
  "block.minecraft.pink_wool": "Rosa Wolle",
  "block.minecraft.piston": "Kolben",
  "block.minecraft.piston_head": "Kolbenkopf",
  "block.minecraft.pitcher_crop": "Kannenpflanzentrieb",
  "block.minecraft.pitcher_plant": "Kannenpflanze",
  "block.minecraft.player_head": "Spielerkopf",
  "block.minecraft.player_head.named": "Kopf von %s",
  "block.minecraft.player_wall_head": "Spieler-Wandkopf",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitzer Tropfstein",
  "block.minecraft.polished_andesite": "Polierter Andesit",
  "block.minecraft.polished_andesite_slab": "Polierte Andesitstufe",
  "block.minecraft.polished_andesite_stairs": "Polierte Andesittreppe",
  "block.minecraft.polished_basalt": "Polierter Basalt",
  "block.minecraft.polished_blackstone": "Polierter Schwarzstein",
  "block.minecraft.polished_blackstone_brick_slab": "Polierte Schwarzsteinziegelstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "Polierte Schwarzsteinziegeltreppe",
  "block.minecraft.polished_blackstone_brick_wall": "Polierte Schwarzsteinziegelmauer",
  "block.minecraft.polished_blackstone_bricks": "Polierte Schwarzsteinziegel",
  "block.minecraft.polished_blackstone_button": "Polierter Schwarzsteinknopf",
  "block.minecraft.polished_blackstone_pressure_plate": "Polierte Schwarzsteindruckplatte",
  "block.minecraft.polished_blackstone_slab": "Polierte Schwarzsteinstufe",
  "block.minecraft.polished_blackstone_stairs": "Polierte Schwarzsteintreppe",
  "block.minecraft.polished_blackstone_wall": "Polierte Schwarzsteinmauer",
  "block.minecraft.polished_deepslate": "Polierter Tiefenschiefer",
  "block.minecraft.polished_deepslate_slab": "Polierte Tiefenschieferstufe",
  "block.minecraft.polished_deepslate_stairs": "Polierte Tiefenschiefertreppe",
  "block.minecraft.polished_deepslate_wall": "Polierte Tiefenschiefermauer",
  "block.minecraft.polished_diorite": "Polierter Diorit",
  "block.minecraft.polished_diorite_slab": "Polierte Dioritstufe",
  "block.minecraft.polished_diorite_stairs": "Polierte Diorittreppe",
  "block.minecraft.polished_granite": "Polierter Granit",
  "block.minecraft.polished_granite_slab": "Polierte Granitstufe",
  "block.minecraft.polished_granite_stairs": "Polierte Granittreppe",
  "block.minecraft.polished_tuff": "Polierter Tuffstein",
  "block.minecraft.polished_tuff_slab": "Polierte Tuffsteinstufe",
  "block.minecraft.polished_tuff_stairs": "Polierte Tuffsteintreppe",
  "block.minecraft.polished_tuff_wall": "Polierte Tuffsteinmauer",
  "block.minecraft.poppy": "Mohn",
  "block.minecraft.potatoes": "Kartoffeln",
  "block.minecraft.potted_acacia_sapling": "Eingetopfter Akaziensetzling",
  "block.minecraft.potted_allium": "Eingetopfter Zierlauch",
  "block.minecraft.potted_azalea_bush": "Eingetopfte Azalee",
  "block.minecraft.potted_azure_bluet": "Eingetopftes Porzellansternchen",
  "block.minecraft.potted_bamboo": "Eingetopfter Bambus",
  "block.minecraft.potted_birch_sapling": "Eingetopfter Birkensetzling",
  "block.minecraft.potted_blue_orchid": "Eingetopfte blaue Orchidee",
  "block.minecraft.potted_brown_mushroom": "Eingetopfter brauner Pilz",
  "block.minecraft.potted_cactus": "Eingetopfter Kaktus",
  "block.minecraft.potted_cherry_sapling": "Eingetopfter Kirschsetzling",
  "block.minecraft.potted_closed_eyeblossom": "Eingetopfte geschlossene Augenblüte",
  "block.minecraft.potted_cornflower": "Eingetopfte Kornblume",
  "block.minecraft.potted_crimson_fungus": "Eingetopfter Karmesinpilz",
  "block.minecraft.potted_crimson_roots": "Eingetopfte Karmesinwurzeln",
  "block.minecraft.potted_dandelion": "Eingetopfter Löwenzahn",
  "block.minecraft.potted_dark_oak_sapling": "Eingetopfter Schwarzeichensetzling",
  "block.minecraft.potted_dead_bush": "Eingetopfter toter Busch",
  "block.minecraft.potted_fern": "Eingetopfter Farn",
  "block.minecraft.potted_flowering_azalea_bush": "Eingetopfte blühende Azalee",
  "block.minecraft.potted_golden_dandelion": "Eingetopfter goldener Löwenzahn",
  "block.minecraft.potted_jungle_sapling": "Eingetopfter Tropenbaumsetzling",
  "block.minecraft.potted_lily_of_the_valley": "Eingetopftes Maiglöckchen",
  "block.minecraft.potted_mangrove_propagule": "Eingetopfter Mangroven-Keimling",
  "block.minecraft.potted_oak_sapling": "Eingetopfter Eichensetzling",
  "block.minecraft.potted_open_eyeblossom": "Eingetopfte geöffnete Augenblüte",
  "block.minecraft.potted_orange_tulip": "Eingetopfte orange Tulpe",
  "block.minecraft.potted_oxeye_daisy": "Eingetopfte Margerite",
  "block.minecraft.potted_pale_oak_sapling": "Eingetopfter Blasseichensetzling",
  "block.minecraft.potted_pink_tulip": "Eingetopfte rosa Tulpe",
  "block.minecraft.potted_poppy": "Eingetopfter Mohn",
  "block.minecraft.potted_red_mushroom": "Eingetopfter roter Pilz",
  "block.minecraft.potted_red_tulip": "Eingetopfte rote Tulpe",
  "block.minecraft.potted_spruce_sapling": "Eingetopfter Fichtensetzling",
  "block.minecraft.potted_torchflower": "Eingetopfte Fackellilie",
  "block.minecraft.potted_warped_fungus": "Eingetopfter Wirrpilz",
  "block.minecraft.potted_warped_roots": "Eingetopfte Wirrwurzeln",
  "block.minecraft.potted_white_tulip": "Eingetopfte weiße Tulpe",
  "block.minecraft.potted_wither_rose": "Eingetopfte Wither-Rose",
  "block.minecraft.powder_snow": "Pulverschnee",
  "block.minecraft.powder_snow_cauldron": "Pulverschneekessel",
  "block.minecraft.powered_rail": "Antriebsschiene",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinziegelstufe",
  "block.minecraft.prismarine_brick_stairs": "Prismarinziegeltreppe",
  "block.minecraft.prismarine_bricks": "Prismarinziegel",
  "block.minecraft.prismarine_slab": "Prismarinstufe",
  "block.minecraft.prismarine_stairs": "Prismarintreppe",
  "block.minecraft.prismarine_wall": "Prismarinmauer",
  "block.minecraft.pumpkin": "Kürbis",
  "block.minecraft.pumpkin_stem": "Kürbispflanze",
  "block.minecraft.purple_banner": "Violettes Banner",
  "block.minecraft.purple_bed": "Violettes Bett",
  "block.minecraft.purple_candle": "Violette Kerze",
  "block.minecraft.purple_candle_cake": "Kuchen mit violetter Kerze",
  "block.minecraft.purple_carpet": "Violetter Teppich",
  "block.minecraft.purple_concrete": "Violetter Beton",
  "block.minecraft.purple_concrete_powder": "Violetter Trockenbeton",
  "block.minecraft.purple_glazed_terracotta": "Violette glasierte Keramik",
  "block.minecraft.purple_shulker_box": "Violette Shulker-Kiste",
  "block.minecraft.purple_stained_glass": "Violettes Glas",
  "block.minecraft.purple_stained_glass_pane": "Violette Glasscheibe",
  "block.minecraft.purple_terracotta": "Violette Keramik",
  "block.minecraft.purple_wool": "Violette Wolle",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpursäule",
  "block.minecraft.purpur_slab": "Purpurstufe",
  "block.minecraft.purpur_stairs": "Purpurtreppe",
  "block.minecraft.quartz_block": "Quarzblock",
  "block.minecraft.quartz_bricks": "Quarzziegel",
  "block.minecraft.quartz_pillar": "Quarzsäule",
  "block.minecraft.quartz_slab": "Quarzstufe",
  "block.minecraft.quartz_stairs": "Quarztreppe",
  "block.minecraft.rail": "Schiene",
  "block.minecraft.raw_copper_block": "Rohkupferblock",
  "block.minecraft.raw_gold_block": "Rohgoldblock",
  "block.minecraft.raw_iron_block": "Roheisenblock",
  "block.minecraft.red_banner": "Rotes Banner",
  "block.minecraft.red_bed": "Rotes Bett",
  "block.minecraft.red_candle": "Rote Kerze",
  "block.minecraft.red_candle_cake": "Kuchen mit roter Kerze",
  "block.minecraft.red_carpet": "Roter Teppich",
  "block.minecraft.red_concrete": "Roter Beton",
  "block.minecraft.red_concrete_powder": "Roter Trockenbeton",
  "block.minecraft.red_glazed_terracotta": "Rote glasierte Keramik",
  "block.minecraft.red_mushroom": "Roter Pilz",
  "block.minecraft.red_mushroom_block": "Roter Pilzblock",
  "block.minecraft.red_nether_brick_slab": "Rote Netherziegelstufe",
  "block.minecraft.red_nether_brick_stairs": "Rote Netherziegeltreppe",
  "block.minecraft.red_nether_brick_wall": "Rote Netherziegelmauer",
  "block.minecraft.red_nether_bricks": "Rote Netherziegel",
  "block.minecraft.red_sand": "Roter Sand",
  "block.minecraft.red_sandstone": "Roter Sandstein",
  "block.minecraft.red_sandstone_slab": "Rote Sandsteinstufe",
  "block.minecraft.red_sandstone_stairs": "Rote Sandsteintreppe",
  "block.minecraft.red_sandstone_wall": "Rote Sandsteinmauer",
  "block.minecraft.red_shulker_box": "Rote Shulker-Kiste",
  "block.minecraft.red_stained_glass": "Rotes Glas",
  "block.minecraft.red_stained_glass_pane": "Rote Glasscheibe",
  "block.minecraft.red_terracotta": "Rote Keramik",
  "block.minecraft.red_tulip": "Rote Tulpe",
  "block.minecraft.red_wool": "Rote Wolle",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Lampe",
  "block.minecraft.redstone_ore": "Redstone-Erz",
  "block.minecraft.redstone_torch": "Redstone-Fackel",
  "block.minecraft.redstone_wall_torch": "Redstone-Wandfackel",
  "block.minecraft.redstone_wire": "Redstone-Leitung",
  "block.minecraft.reinforced_deepslate": "Verstärkter Tiefenschiefer",
  "block.minecraft.repeater": "Redstone-Verstärker",
  "block.minecraft.repeating_command_block": "Wiederhol-Befehlsblock",
  "block.minecraft.resin_block": "Harzblock",
  "block.minecraft.resin_brick_slab": "Harzziegelstufe",
  "block.minecraft.resin_brick_stairs": "Harzziegeltreppe",
  "block.minecraft.resin_brick_wall": "Harzziegelmauer",
  "block.minecraft.resin_bricks": "Harzziegel",
  "block.minecraft.resin_clump": "Harzklumpen",
  "block.minecraft.respawn_anchor": "Seelenanker",
  "block.minecraft.rooted_dirt": "Wurzelerde",
  "block.minecraft.rose_bush": "Rosenstrauch",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstein",
  "block.minecraft.sandstone_slab": "Sandsteinstufe",
  "block.minecraft.sandstone_stairs": "Sandsteintreppe",
  "block.minecraft.sandstone_wall": "Sandsteinmauer",
  "block.minecraft.scaffolding": "Gerüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kreischer",
  "block.minecraft.sculk_vein": "Sculk-Ader",
  "block.minecraft.sea_lantern": "Seelaterne",
  "block.minecraft.sea_pickle": "Meeresgurke",
  "block.minecraft.seagrass": "Seegras",
  "block.minecraft.set_spawn": "Wiedereinstiegspunkt gesetzt",
  "block.minecraft.short_dry_grass": "Niedriges Trockengras",
  "block.minecraft.short_grass": "Niedriges Gras",
  "block.minecraft.shroomlight": "Pilzlicht",
  "block.minecraft.shulker_box": "Shulker-Kiste",
  "block.minecraft.skeleton_skull": "Skelettschädel",
  "block.minecraft.skeleton_wall_skull": "Skelett-Wandschädel",
  "block.minecraft.slime_block": "Schleimblock",
  "block.minecraft.small_amethyst_bud": "Kleine Amethystknospe",
  "block.minecraft.small_dripleaf": "Kleines Tropfblatt",
  "block.minecraft.smithing_table": "Schmiedetisch",
  "block.minecraft.smoker": "Räucherofen",
  "block.minecraft.smooth_basalt": "Glatter Basalt",
  "block.minecraft.smooth_quartz": "Glatter Quarzblock",
  "block.minecraft.smooth_quartz_slab": "Glatte Quarzstufe",
  "block.minecraft.smooth_quartz_stairs": "Glatte Quarztreppe",
  "block.minecraft.smooth_red_sandstone": "Glatter roter Sandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Glatte rote Sandsteinstufe",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatte rote Sandsteintreppe",
  "block.minecraft.smooth_sandstone": "Glatter Sandstein",
  "block.minecraft.smooth_sandstone_slab": "Glatte Sandsteinstufe",
  "block.minecraft.smooth_sandstone_stairs": "Glatte Sandsteintreppe",
  "block.minecraft.smooth_stone": "Glatter Stein",
  "block.minecraft.smooth_stone_slab": "Glatte Steinstufe",
  "block.minecraft.sniffer_egg": "Schnüffler-Ei",
  "block.minecraft.snow": "Schnee",
  "block.minecraft.snow_block": "Schneeblock",
  "block.minecraft.soul_campfire": "Seelenlagerfeuer",
  "block.minecraft.soul_fire": "Seelenfeuer",
  "block.minecraft.soul_lantern": "Seelenlaterne",
  "block.minecraft.soul_sand": "Seelensand",
  "block.minecraft.soul_soil": "Seelenerde",
  "block.minecraft.soul_torch": "Seelenfackel",
  "block.minecraft.soul_wall_torch": "Seelenwandfackel",
  "block.minecraft.spawn.not_valid": "Du hast kein Bett und keinen aufgeladenen Seelenanker, oder dein Wiedereinstiegspunkt wurde blockiert",
  "block.minecraft.spawner": "Spawner",
  "block.minecraft.spawner.desc1": "Benutze Spawn‐Ei:",
  "block.minecraft.spawner.desc2": "Legt Kreaturentyp fest",
  "block.minecraft.sponge": "Schwamm",
  "block.minecraft.spore_blossom": "Sporenblüte",
  "block.minecraft.spruce_button": "Fichtenholzknopf",
  "block.minecraft.spruce_door": "Fichtenholztür",
  "block.minecraft.spruce_fence": "Fichtenholzzaun",
  "block.minecraft.spruce_fence_gate": "Fichtenholzzauntor",
  "block.minecraft.spruce_hanging_sign": "Fichtenholzhängeschild",
  "block.minecraft.spruce_leaves": "Fichtennadeln",
  "block.minecraft.spruce_log": "Fichtenstamm",
  "block.minecraft.spruce_planks": "Fichtenholzbretter",
  "block.minecraft.spruce_pressure_plate": "Fichtenholzdruckplatte",
  "block.minecraft.spruce_sapling": "Fichtensetzling",
  "block.minecraft.spruce_shelf": "Fichtenholzregal",
  "block.minecraft.spruce_sign": "Fichtenholzschild",
  "block.minecraft.spruce_slab": "Fichtenholzstufe",
  "block.minecraft.spruce_stairs": "Fichtenholztreppe",
  "block.minecraft.spruce_trapdoor": "Fichtenholzfalltür",
  "block.minecraft.spruce_wall_hanging_sign": "Fichtenholzwandhängeschild",
  "block.minecraft.spruce_wall_sign": "Fichtenholzwandschild",
  "block.minecraft.spruce_wood": "Fichtenholz",
  "block.minecraft.sticky_piston": "Klebriger Kolben",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Steinziegelstufe",
  "block.minecraft.stone_brick_stairs": "Steinziegeltreppe",
  "block.minecraft.stone_brick_wall": "Steinziegelmauer",
  "block.minecraft.stone_bricks": "Steinziegel",
  "block.minecraft.stone_button": "Steinknopf",
  "block.minecraft.stone_pressure_plate": "Steindruckplatte",
  "block.minecraft.stone_slab": "Steinstufe",
  "block.minecraft.stone_stairs": "Steintreppe",
  "block.minecraft.stonecutter": "Steinsäge",
  "block.minecraft.stripped_acacia_log": "Entrindeter Akazienstamm",
  "block.minecraft.stripped_acacia_wood": "Entrindetes Akazienholz",
  "block.minecraft.stripped_bamboo_block": "Geschälter Bambusblock",
  "block.minecraft.stripped_birch_log": "Entrindeter Birkenstamm",
  "block.minecraft.stripped_birch_wood": "Entrindetes Birkenholz",
  "block.minecraft.stripped_cherry_log": "Entrindeter Kirschstamm",
  "block.minecraft.stripped_cherry_wood": "Entrindetes Kirschholz",
  "block.minecraft.stripped_crimson_hyphae": "Geschälte Karmesinhyphen",
  "block.minecraft.stripped_crimson_stem": "Geschälter Karmesinstiel",
  "block.minecraft.stripped_dark_oak_log": "Entrindeter Schwarzeichenstamm",
  "block.minecraft.stripped_dark_oak_wood": "Entrindetes Schwarzeichenholz",
  "block.minecraft.stripped_jungle_log": "Entrindeter Tropenbaumstamm",
  "block.minecraft.stripped_jungle_wood": "Entrindetes Tropenholz",
  "block.minecraft.stripped_mangrove_log": "Entrindeter Mangrovenstamm",
  "block.minecraft.stripped_mangrove_wood": "Entrindetes Mangrovenholz",
  "block.minecraft.stripped_oak_log": "Entrindeter Eichenstamm",
  "block.minecraft.stripped_oak_wood": "Entrindetes Eichenholz",
  "block.minecraft.stripped_pale_oak_log": "Entrindeter Blasseichenstamm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindetes Blasseichenholz",
  "block.minecraft.stripped_spruce_log": "Entrindeter Fichtenstamm",
  "block.minecraft.stripped_spruce_wood": "Entrindetes Fichtenholz",
  "block.minecraft.stripped_warped_hyphae": "Geschälte Wirrhyphen",
  "block.minecraft.stripped_warped_stem": "Geschälter Wirrstiel",
  "block.minecraft.structure_block": "Konstruktionsblock",
  "block.minecraft.structure_void": "Konstruktionsleere",
  "block.minecraft.sugar_cane": "Zuckerrohr",
  "block.minecraft.sunflower": "Sonnenblume",
  "block.minecraft.suspicious_gravel": "Seltsamer Kies",
  "block.minecraft.suspicious_sand": "Seltsamer Sand",
  "block.minecraft.sweet_berry_bush": "Süßbeerstrauch",
  "block.minecraft.tall_dry_grass": "Hohes Trockengras",
  "block.minecraft.tall_grass": "Hohes Gras",
  "block.minecraft.tall_seagrass": "Hohes Seegras",
  "block.minecraft.target": "Zielblock",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Getöntes Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT‐Explosionen sind deaktiviert",
  "block.minecraft.torch": "Fackel",
  "block.minecraft.torchflower": "Fackellilie",
  "block.minecraft.torchflower_crop": "Fackellilienpflanze",
  "block.minecraft.trapped_chest": "Redstone-Truhe",
  "block.minecraft.trial_spawner": "Prüfungs-Spawner",
  "block.minecraft.tripwire": "Stolperdraht",
  "block.minecraft.tripwire_hook": "Haken",
  "block.minecraft.tube_coral": "Orgelkoralle",
  "block.minecraft.tube_coral_block": "Orgelkorallenblock",
  "block.minecraft.tube_coral_fan": "Orgelkorallenfächer",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallenwandfächer",
  "block.minecraft.tuff": "Tuffstein",
  "block.minecraft.tuff_brick_slab": "Tuffsteinziegelstufe",
  "block.minecraft.tuff_brick_stairs": "Tuffsteinziegeltreppe",
  "block.minecraft.tuff_brick_wall": "Tuffsteinziegelmauer",
  "block.minecraft.tuff_bricks": "Tuffsteinziegel",
  "block.minecraft.tuff_slab": "Tuffsteinstufe",
  "block.minecraft.tuff_stairs": "Tuffsteintreppe",
  "block.minecraft.tuff_wall": "Tuffsteinmauer",
  "block.minecraft.turtle_egg": "Schildkrötenei",
  "block.minecraft.twisting_vines": "Zwirbelranken",
  "block.minecraft.twisting_vines_plant": "Zwirbelrankenpflanze",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Junggrünes Froschlicht",
  "block.minecraft.vine": "Ranken",
  "block.minecraft.void_air": "Leerenluft",
  "block.minecraft.wall_torch": "Wandfackel",
  "block.minecraft.warped_button": "Wirrknopf",
  "block.minecraft.warped_door": "Wirrtür",
  "block.minecraft.warped_fence": "Wirrzaun",
  "block.minecraft.warped_fence_gate": "Wirrzauntor",
  "block.minecraft.warped_fungus": "Wirrpilz",
  "block.minecraft.warped_hanging_sign": "Wirrhängeschild",
  "block.minecraft.warped_hyphae": "Wirrhyphen",
  "block.minecraft.warped_nylium": "Wirr-Nezel",
  "block.minecraft.warped_planks": "Wirrbretter",
  "block.minecraft.warped_pressure_plate": "Wirrdruckplatte",
  "block.minecraft.warped_roots": "Wirrwurzeln",
  "block.minecraft.warped_shelf": "Wirrregal",
  "block.minecraft.warped_sign": "Wirrschild",
  "block.minecraft.warped_slab": "Wirrstufe",
  "block.minecraft.warped_stairs": "Wirrtreppe",
  "block.minecraft.warped_stem": "Wirrstiel",
  "block.minecraft.warped_trapdoor": "Wirrfalltür",
  "block.minecraft.warped_wall_hanging_sign": "Wirrwandhängeschild",
  "block.minecraft.warped_wall_sign": "Wirrwandschild",
  "block.minecraft.warped_wart_block": "Wirrwarzenblock",
  "block.minecraft.water": "Wasser",
  "block.minecraft.water_cauldron": "Wasserkessel",
  "block.minecraft.waxed_chiseled_copper": "Gewachster gemeißelter Kupferblock",
  "block.minecraft.waxed_copper_bars": "Gewachstes Kupfergitter",
  "block.minecraft.waxed_copper_block": "Gewachster Kupferblock",
  "block.minecraft.waxed_copper_bulb": "Gewachste Kupferleuchte",
  "block.minecraft.waxed_copper_chain": "Gewachste Kupferkette",
  "block.minecraft.waxed_copper_chest": "Gewachste Kupfertruhe",
  "block.minecraft.waxed_copper_door": "Gewachste Kupfertür",
  "block.minecraft.waxed_copper_golem_statue": "Gewachste Kupfergolemstatue",
  "block.minecraft.waxed_copper_grate": "Gewachster Kupferrost",
  "block.minecraft.waxed_copper_lantern": "Gewachste Kupferlaterne",
  "block.minecraft.waxed_copper_trapdoor": "Gewachste Kupferfalltür",
  "block.minecraft.waxed_cut_copper": "Gewachster geschnittener Kupferblock",
  "block.minecraft.waxed_cut_copper_slab": "Gewachste geschnittene Kupferstufe",
  "block.minecraft.waxed_cut_copper_stairs": "Gewachste geschnittene Kupfertreppe",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gewachster angelaufener gemeißelter Kupferblock",
  "block.minecraft.waxed_exposed_copper": "Gewachster angelaufener Kupferblock",
  "block.minecraft.waxed_exposed_copper_bars": "Gewachstes angelaufenes Kupfergitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewachste angelaufene Kupferleuchte",
  "block.minecraft.waxed_exposed_copper_chain": "Gewachste angelaufene Kupferkette",
  "block.minecraft.waxed_exposed_copper_chest": "Gewachste angelaufene Kupfertruhe",
  "block.minecraft.waxed_exposed_copper_door": "Gewachste angelaufene Kupfertür",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gewachste angelaufene Kupfergolemstatue",
  "block.minecraft.waxed_exposed_copper_grate": "Gewachster angelaufener Kupferrost",
  "block.minecraft.waxed_exposed_copper_lantern": "Gewachste angelaufene Kupferlaterne",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gewachste angelaufene Kupferfalltür",
  "block.minecraft.waxed_exposed_cut_copper": "Gewachster angelaufener geschnittener Kupferblock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewachste angelaufene geschnittene Kupferstufe",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gewachste angelaufene geschnittene Kupfertreppe",
  "block.minecraft.waxed_exposed_lightning_rod": "Gewachster angelaufener Blitzableiter",
  "block.minecraft.waxed_lightning_rod": "Gewachster Blitzableiter",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gewachster oxidierter gemeißelter Kupferblock",
  "block.minecraft.waxed_oxidized_copper": "Gewachster oxidierter Kupferblock",
  "block.minecraft.waxed_oxidized_copper_bars": "Gewachstes oxidiertes Kupfergitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gewachste oxidierte Kupferleuchte",
  "block.minecraft.waxed_oxidized_copper_chain": "Gewachste oxidierte Kupferkette",
  "block.minecraft.waxed_oxidized_copper_chest": "Gewachste oxidierte Kupfertruhe",
  "block.minecraft.waxed_oxidized_copper_door": "Gewachste oxidierte Kupfertür",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gewachste oxidierte Kupfergolemstatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gewachster oxidierter Kupferrost",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gewachste oxidierte Kupferlaterne",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gewachste oxidierte Kupferfalltür",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewachster oxidierter geschnittener Kupferblock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewachste oxidierte geschnittene Kupferstufe",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gewachste oxidierte geschnittene Kupfertreppe",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gewachster oxidierter Blitzableiter",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gewachster verwitterter gemeißelter Kupferblock",
  "block.minecraft.waxed_weathered_copper": "Gewachster verwitterter Kupferblock",
  "block.minecraft.waxed_weathered_copper_bars": "Gewachstes verwittertes Kupfergitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Gewachste verwitterte Kupferleuchte",
  "block.minecraft.waxed_weathered_copper_chain": "Gewachste verwitterte Kupferkette",
  "block.minecraft.waxed_weathered_copper_chest": "Gewachste verwitterte Kupfertruhe",
  "block.minecraft.waxed_weathered_copper_door": "Gewachste verwitterte Kupfertür",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gewachste verwitterte Kupfergolemstatue",
  "block.minecraft.waxed_weathered_copper_grate": "Gewachster verwitterter Kupferrost",
  "block.minecraft.waxed_weathered_copper_lantern": "Gewachste verwitterte Kupferlaterne",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gewachste verwitterte Kupferfalltür",
  "block.minecraft.waxed_weathered_cut_copper": "Gewachster verwitterter geschnittener Kupferblock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewachste verwitterte geschnittene Kupferstufe",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gewachste verwitterte geschnittene Kupfertreppe",
  "block.minecraft.waxed_weathered_lightning_rod": "Gewachster verwitterter Blitzableiter",
  "block.minecraft.weathered_chiseled_copper": "Verwitterter gemeißelter Kupferblock",
  "block.minecraft.weathered_copper": "Verwitterter Kupferblock",
  "block.minecraft.weathered_copper_bars": "Verwittertes Kupfergitter",
  "block.minecraft.weathered_copper_bulb": "Verwitterte Kupferleuchte",
  "block.minecraft.weathered_copper_chain": "Verwitterte Kupferkette",
  "block.minecraft.weathered_copper_chest": "Verwitterte Kupfertruhe",
  "block.minecraft.weathered_copper_door": "Verwitterte Kupfertür",
  "block.minecraft.weathered_copper_golem_statue": "Verwitterte Kupfergolemstatue",
  "block.minecraft.weathered_copper_grate": "Verwitterter Kupferrost",
  "block.minecraft.weathered_copper_lantern": "Verwitterte Kupferlaterne",
  "block.minecraft.weathered_copper_trapdoor": "Verwitterte Kupferfalltür",
  "block.minecraft.weathered_cut_copper": "Verwitterter geschnittener Kupferblock",
  "block.minecraft.weathered_cut_copper_slab": "Verwitterte geschnittene Kupferstufe",
  "block.minecraft.weathered_cut_copper_stairs": "Verwitterte geschnittene Kupfertreppe",
  "block.minecraft.weathered_lightning_rod": "Verwitterter Blitzableiter",
  "block.minecraft.weeping_vines": "Trauerranken",
  "block.minecraft.weeping_vines_plant": "Trauerrankenpflanze",
  "block.minecraft.wet_sponge": "Nasser Schwamm",
  "block.minecraft.wheat": "Weizenpflanze",
  "block.minecraft.white_banner": "Weißes Banner",
  "block.minecraft.white_bed": "Weißes Bett",
  "block.minecraft.white_candle": "Weiße Kerze",
  "block.minecraft.white_candle_cake": "Kuchen mit weißer Kerze",
  "block.minecraft.white_carpet": "Weißer Teppich",
  "block.minecraft.white_concrete": "Weißer Beton",
  "block.minecraft.white_concrete_powder": "Weißer Trockenbeton",
  "block.minecraft.white_glazed_terracotta": "Weiße glasierte Keramik",
  "block.minecraft.white_shulker_box": "Weiße Shulker-Kiste",
  "block.minecraft.white_stained_glass": "Weißes Glas",
  "block.minecraft.white_stained_glass_pane": "Weiße Glasscheibe",
  "block.minecraft.white_terracotta": "Weiße Keramik",
  "block.minecraft.white_tulip": "Weiße Tulpe",
  "block.minecraft.white_wool": "Weiße Wolle",
  "block.minecraft.wildflowers": "Wildblumen",
  "block.minecraft.wither_rose": "Wither-Rose",
  "block.minecraft.wither_skeleton_skull": "Wither-Skelettschädel",
  "block.minecraft.wither_skeleton_wall_skull": "Wither-Skelett-Wandschädel",
  "block.minecraft.yellow_banner": "Gelbes Banner",
  "block.minecraft.yellow_bed": "Gelbes Bett",
  "block.minecraft.yellow_candle": "Gelbe Kerze",
  "block.minecraft.yellow_candle_cake": "Kuchen mit gelber Kerze",
  "block.minecraft.yellow_carpet": "Gelber Teppich",
  "block.minecraft.yellow_concrete": "Gelber Beton",
  "block.minecraft.yellow_concrete_powder": "Gelber Trockenbeton",
  "block.minecraft.yellow_glazed_terracotta": "Gelbe glasierte Keramik",
  "block.minecraft.yellow_shulker_box": "Gelbe Shulker-Kiste",
  "block.minecraft.yellow_stained_glass": "Gelbes Glas",
  "block.minecraft.yellow_stained_glass_pane": "Gelbe Glasscheibe",
  "block.minecraft.yellow_terracotta": "Gelbe Keramik",
  "block.minecraft.yellow_wool": "Gelbe Wolle",
  "block.minecraft.zombie_head": "Zombiekopf",
  "block.minecraft.zombie_wall_head": "Zombie-Wandkopf",
  "item.minecraft.acacia_boat": "Akazienholzboot",
  "item.minecraft.acacia_chest_boat": "Akazienholztruhenboot",
  "item.minecraft.allay_spawn_egg": "Hilfsgeister-Spawn-Ei",
  "item.minecraft.amethyst_shard": "Amethystscherbe",
  "item.minecraft.angler_pottery_shard": "Angler-Töpferscherbe",
  "item.minecraft.angler_pottery_sherd": "Angler-Töpferscherbe",
  "item.minecraft.apple": "Apfel",
  "item.minecraft.archer_pottery_shard": "Schützen-Töpferscherbe",
  "item.minecraft.archer_pottery_sherd": "Schützen-Töpferscherbe",
  "item.minecraft.armadillo_scute": "Gürteltier-Hornschild",
  "item.minecraft.armadillo_spawn_egg": "Gürteltier-Spawn-Ei",
  "item.minecraft.armor_stand": "Rüstungsständer",
  "item.minecraft.arms_up_pottery_shard": "Gebärden-Töpferscherbe",
  "item.minecraft.arms_up_pottery_sherd": "Gebärden-Töpferscherbe",
  "item.minecraft.arrow": "Pfeil",
  "item.minecraft.axolotl_bucket": "Axolotleimer",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ei",
  "item.minecraft.baked_potato": "Ofenkartoffel",
  "item.minecraft.bamboo_chest_raft": "Bambus-Truhenfloß",
  "item.minecraft.bamboo_raft": "Bambusfloß",
  "item.minecraft.bat_spawn_egg": "Fledermaus-Spawn-Ei",
  "item.minecraft.bee_spawn_egg": "Bienen-Spawn-Ei",
  "item.minecraft.beef": "Rohes Rindfleisch",
  "item.minecraft.beetroot": "Rote Bete",
  "item.minecraft.beetroot_seeds": "Rote-Bete-Samen",
  "item.minecraft.beetroot_soup": "Borschtsch",
  "item.minecraft.birch_boat": "Birkenholzboot",
  "item.minecraft.birch_chest_boat": "Birkenholztruhenboot",
  "item.minecraft.black_bundle": "Schwarzes Bündel",
  "item.minecraft.black_dye": "Schwarzer Farbstoff",
  "item.minecraft.black_harness": "Schwarzes Geschirr",
  "item.minecraft.blade_pottery_shard": "Klingen-Töpferscherbe",
  "item.minecraft.blade_pottery_sherd": "Klingen-Töpferscherbe",
  "item.minecraft.blaze_powder": "Lohenstaub",
  "item.minecraft.blaze_rod": "Lohenrute",
  "item.minecraft.blaze_spawn_egg": "Lohen-Spawn-Ei",
  "item.minecraft.blue_bundle": "Blaues Bündel",
  "item.minecraft.blue_dye": "Blauer Farbstoff",
  "item.minecraft.blue_egg": "Blaues Ei",
  "item.minecraft.blue_harness": "Blaues Geschirr",
  "item.minecraft.bogged_spawn_egg": "Sumpfskelett-Spawn-Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolzen-Rüstungsbesatz",
  "item.minecraft.bone": "Knochen",
  "item.minecraft.bone_meal": "Knochenmehl",
  "item.minecraft.book": "Buch",
  "item.minecraft.bordure_indented_banner_pattern": "Spickelbord-Bannervorlage",
  "item.minecraft.bow": "Bogen",
  "item.minecraft.bowl": "Schüssel",
  "item.minecraft.bread": "Brot",
  "item.minecraft.breeze_rod": "Böenrute",
  "item.minecraft.breeze_spawn_egg": "Böen-Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töpferscherbe",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töpferscherbe",
  "item.minecraft.brewing_stand": "Braustand",
  "item.minecraft.brick": "Ziegel",
  "item.minecraft.brown_bundle": "Braunes Bündel",
  "item.minecraft.brown_dye": "Brauner Farbstoff",
  "item.minecraft.brown_egg": "Braunes Ei",
  "item.minecraft.brown_harness": "Braunes Geschirr",
  "item.minecraft.brush": "Pinsel",
  "item.minecraft.bucket": "Eimer",
  "item.minecraft.bundle": "Bündel",
  "item.minecraft.bundle.empty": "Leer",
  "item.minecraft.bundle.empty.description": "Nimmt einen gemischten Stapel Gegenstände auf",
  "item.minecraft.bundle.full": "Voll",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flammen-Töpferscherbe",
  "item.minecraft.burn_pottery_sherd": "Flammen-Töpferscherbe",
  "item.minecraft.camel_husk_spawn_egg": "Zombiedromedar-Spawn-Ei",
  "item.minecraft.camel_spawn_egg": "Dromedar-Spawn-Ei",
  "item.minecraft.carrot": "Karotte",
  "item.minecraft.carrot_on_a_stick": "Karottenrute",
  "item.minecraft.cat_spawn_egg": "Katzen-Spawn-Ei",
  "item.minecraft.cauldron": "Kessel",
  "item.minecraft.cave_spider_spawn_egg": "Höhlenspinnen-Spawn-Ei",
  "item.minecraft.chainmail_boots": "Kettenstiefel",
  "item.minecraft.chainmail_chestplate": "Kettenhemd",
  "item.minecraft.chainmail_helmet": "Kettenhaube",
  "item.minecraft.chainmail_leggings": "Kettenhose",
  "item.minecraft.charcoal": "Holzkohle",
  "item.minecraft.cherry_boat": "Kirschholzboot",
  "item.minecraft.cherry_chest_boat": "Kirschholztruhenboot",
  "item.minecraft.chest_minecart": "Güterlore",
  "item.minecraft.chicken": "Rohes Hühnchen",
  "item.minecraft.chicken_spawn_egg": "Huhn-Spawn-Ei",
  "item.minecraft.chorus_fruit": "Chorusfrucht",
  "item.minecraft.clay_ball": "Tonklumpen",
  "item.minecraft.clock": "Uhr",
  "item.minecraft.coal": "Kohle",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Küsten-Rüstungsbesatz",
  "item.minecraft.cocoa_beans": "Kakaobohnen",
  "item.minecraft.cod": "Roher Kabeljau",
  "item.minecraft.cod_bucket": "Kabeljaueimer",
  "item.minecraft.cod_spawn_egg": "Kabeljau-Spawn-Ei",
  "item.minecraft.command_block_minecart": "Befehlsblocklore",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Gebratenes Hühnchen",
  "item.minecraft.cooked_cod": "Gebratener Kabeljau",
  "item.minecraft.cooked_mutton": "Gebratenes Hammelfleisch",
  "item.minecraft.cooked_porkchop": "Gebratenes Schweinefleisch",
  "item.minecraft.cooked_rabbit": "Gebratenes Kaninchen",
  "item.minecraft.cooked_salmon": "Gebratener Lachs",
  "item.minecraft.cookie": "Keks",
  "item.minecraft.copper_axe": "Kupferaxt",
  "item.minecraft.copper_boots": "Kupferstiefel",
  "item.minecraft.copper_chestplate": "Kupferharnisch",
  "item.minecraft.copper_golem_spawn_egg": "Kupfergolem-Spawn-Ei",
  "item.minecraft.copper_helmet": "Kupferhelm",
  "item.minecraft.copper_hoe": "Kupferhacke",
  "item.minecraft.copper_horse_armor": "Kupferner Rossharnisch",
  "item.minecraft.copper_ingot": "Kupferbarren",
  "item.minecraft.copper_leggings": "Kupferbeinschutz",
  "item.minecraft.copper_nautilus_armor": "Kupferner Nautiluspanzer",
  "item.minecraft.copper_nugget": "Kupferklumpen",
  "item.minecraft.copper_pickaxe": "Kupferspitzhacke",
  "item.minecraft.copper_shovel": "Kupferschaufel",
  "item.minecraft.copper_spear": "Kupferspeer",
  "item.minecraft.copper_sword": "Kupferschwert",
  "item.minecraft.cow_spawn_egg": "Kuh-Spawn-Ei",
  "item.minecraft.creaking_spawn_egg": "Knarz-Spawn-Ei",
  "item.minecraft.creeper_banner_pattern": "Bannervorlage",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervorlage",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ei",
  "item.minecraft.crossbow": "Armbrust",
  "item.minecraft.crossbow.projectile": "Geschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Geschoss: %s× %s",
  "item.minecraft.crossbow.projectile.single": "Geschoss: %s",
  "item.minecraft.cyan_bundle": "Türkises Bündel",
  "item.minecraft.cyan_dye": "Türkiser Farbstoff",
  "item.minecraft.cyan_harness": "Türkises Geschirr",
  "item.minecraft.danger_pottery_shard": "Gefahren-Töpferscherbe",
  "item.minecraft.danger_pottery_sherd": "Gefahren-Töpferscherbe",
  "item.minecraft.dark_oak_boat": "Schwarzeichenholzboot",
  "item.minecraft.dark_oak_chest_boat": "Schwarzeichenholztruhenboot",
  "item.minecraft.debug_stick": "Debug-Stab",
  "item.minecraft.debug_stick.empty": "%s hat keine Blockzustände",
  "item.minecraft.debug_stick.select": "‚%s‘ ausgewählt (%s)",
  "item.minecraft.debug_stick.update": "‚%s‘ ist jetzt %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantaxt",
  "item.minecraft.diamond_boots": "Diamantstiefel",
  "item.minecraft.diamond_chestplate": "Diamantharnisch",
  "item.minecraft.diamond_helmet": "Diamanthelm",
  "item.minecraft.diamond_hoe": "Diamanthacke",
  "item.minecraft.diamond_horse_armor": "Diamantener Rossharnisch",
  "item.minecraft.diamond_leggings": "Diamantbeinschutz",
  "item.minecraft.diamond_nautilus_armor": "Diamantener Nautiluspanzer",
  "item.minecraft.diamond_pickaxe": "Diamantspitzhacke",
  "item.minecraft.diamond_shovel": "Diamantschaufel",
  "item.minecraft.diamond_spear": "Diamantspeer",
  "item.minecraft.diamond_sword": "Diamantschwert",
  "item.minecraft.disc_fragment_5": "Plattenbruchstück",
  "item.minecraft.disc_fragment_5.desc": "Schallplatte - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ei",
  "item.minecraft.donkey_spawn_egg": "Esel-Spawn-Ei",
  "item.minecraft.dragon_breath": "Drachenatem",
  "item.minecraft.dried_kelp": "Getrockneter Seetang",
  "item.minecraft.drowned_spawn_egg": "Ertrunkenen-Spawn-Ei",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungsbesatz",
  "item.minecraft.echo_shard": "Echoscherbe",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Großwächter-Spawn-Ei",
  "item.minecraft.elytra": "Elytren",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Verzaubertes Buch",
  "item.minecraft.enchanted_golden_apple": "Verzauberter goldener Apfel",
  "item.minecraft.end_crystal": "Enderkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrachen-Spawn-Ei",
  "item.minecraft.ender_eye": "Enderauge",
  "item.minecraft.ender_pearl": "Enderperle",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ei",
  "item.minecraft.endermite_spawn_egg": "Endermiten-Spawn-Ei",
  "item.minecraft.evoker_spawn_egg": "Magier-Spawn-Ei",
  "item.minecraft.experience_bottle": "Erfahrungsfläschchen",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Töpferscherbe",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Töpferscherbe",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Augen-Rüstungsbesatz",
  "item.minecraft.feather": "Feder",
  "item.minecraft.fermented_spider_eye": "Fermentiertes Spinnenauge",
  "item.minecraft.field_masoned_banner_pattern": "Mauerung-Bannervorlage",
  "item.minecraft.filled_map": "Karte",
  "item.minecraft.fire_charge": "Feuerkugel",
  "item.minecraft.firework_rocket": "Feuerwerksrakete",
  "item.minecraft.firework_rocket.flight": "Flugdauer:",
  "item.minecraft.firework_rocket.multiple_stars": "%s× %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feuerwerksstern",
  "item.minecraft.firework_star.black": "Schwarz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Braun",
  "item.minecraft.firework_star.custom_color": "Benutzerdefiniert",
  "item.minecraft.firework_star.cyan": "Türkis",
  "item.minecraft.firework_star.fade_to": "Übergang zu",
  "item.minecraft.firework_star.flicker": "Funkeln",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grün",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Hellgrau",
  "item.minecraft.firework_star.lime": "Hellgrün",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Violett",
  "item.minecraft.firework_star.red": "Rot",
  "item.minecraft.firework_star.shape": "Unbekannte Form",
  "item.minecraft.firework_star.shape.burst": "Explosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperförmig",
  "item.minecraft.firework_star.shape.large_ball": "Große Kugel",
  "item.minecraft.firework_star.shape.small_ball": "Kleine Kugel",
  "item.minecraft.firework_star.shape.star": "Sternförmig",
  "item.minecraft.firework_star.trail": "Schweif",
  "item.minecraft.firework_star.white": "Weiß",
  "item.minecraft.firework_star.yellow": "Gelb",
  "item.minecraft.fishing_rod": "Angel",
  "item.minecraft.flint": "Feuerstein",
  "item.minecraft.flint_and_steel": "Feuerzeug",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstungsbesatz",
  "item.minecraft.flow_banner_pattern": "Bannervorlage",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervorlage",
  "item.minecraft.flow_pottery_sherd": "Fluss-Töpferscherbe",
  "item.minecraft.flower_banner_pattern": "Bannervorlage",
  "item.minecraft.flower_banner_pattern.desc": "Blume",
  "item.minecraft.flower_banner_pattern.new": "Blumen-Bannervorlage",
  "item.minecraft.flower_pot": "Blumentopf",
  "item.minecraft.fox_spawn_egg": "Fuchs-Spawn-Ei",
  "item.minecraft.friend_pottery_shard": "Freundes-Töpferscherbe",
  "item.minecraft.friend_pottery_sherd": "Freundes-Töpferscherbe",
  "item.minecraft.frog_spawn_egg": "Frosch-Spawn-Ei",
  "item.minecraft.furnace_minecart": "Antriebslore",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ei",
  "item.minecraft.ghast_tear": "Ghast-Träne",
  "item.minecraft.glass_bottle": "Glasflasche",
  "item.minecraft.glistering_melon_slice": "Glitzernde Melonenscheibe",
  "item.minecraft.globe_banner_pattern": "Bannervorlage",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervorlage",
  "item.minecraft.glow_berries": "Leuchtbeeren",
  "item.minecraft.glow_ink_sac": "Leuchttintenbeutel",
  "item.minecraft.glow_item_frame": "Leuchtrahmen",
  "item.minecraft.glow_squid_spawn_egg": "Leuchttintenfisch-Spawn-Ei",
  "item.minecraft.glowstone_dust": "Leuchtsteinstaub",
  "item.minecraft.goat_horn": "Bockshorn",
  "item.minecraft.goat_spawn_egg": "Ziegen-Spawn-Ei",
  "item.minecraft.gold_ingot": "Goldbarren",
  "item.minecraft.gold_nugget": "Goldklumpen",
  "item.minecraft.golden_apple": "Goldener Apfel",
  "item.minecraft.golden_axe": "Goldaxt",
  "item.minecraft.golden_boots": "Goldstiefel",
  "item.minecraft.golden_carrot": "Goldene Karotte",
  "item.minecraft.golden_chestplate": "Goldharnisch",
  "item.minecraft.golden_helmet": "Goldhelm",
  "item.minecraft.golden_hoe": "Goldhacke",
  "item.minecraft.golden_horse_armor": "Goldener Rossharnisch",
  "item.minecraft.golden_leggings": "Goldbeinschutz",
  "item.minecraft.golden_nautilus_armor": "Goldener Nautiluspanzer",
  "item.minecraft.golden_pickaxe": "Goldspitzhacke",
  "item.minecraft.golden_shovel": "Goldschaufel",
  "item.minecraft.golden_spear": "Goldspeer",
  "item.minecraft.golden_sword": "Goldschwert",
  "item.minecraft.gray_bundle": "Graues Bündel",
  "item.minecraft.gray_dye": "Grauer Farbstoff",
  "item.minecraft.gray_harness": "Graues Geschirr",
  "item.minecraft.green_bundle": "Grünes Bündel",
  "item.minecraft.green_dye": "Grüner Farbstoff",
  "item.minecraft.green_harness": "Grünes Geschirr",
  "item.minecraft.guardian_spawn_egg": "Wächter-Spawn-Ei",
  "item.minecraft.gunpowder": "Schwarzpulver",
  "item.minecraft.guster_banner_pattern": "Bannervorlage",
  "item.minecraft.guster_banner_pattern.desc": "Windstoßer",
  "item.minecraft.guster_banner_pattern.new": "Windstoßer-Bannervorlage",
  "item.minecraft.guster_pottery_sherd": "Windstoßer-Töpferscherbe",
  "item.minecraft.happy_ghast_spawn_egg": "Glücklicher-Ghast-Spawn-Ei",
  "item.minecraft.harness": "Geschirr",
  "item.minecraft.heart_of_the_sea": "Herz des Meeres",
  "item.minecraft.heart_pottery_shard": "Herz-Töpferscherbe",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_shard": "Herzschmerz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_sherd": "Herzschmerz-Töpferscherbe",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ei",
  "item.minecraft.honey_bottle": "Honigflasche",
  "item.minecraft.honeycomb": "Honigwabe",
  "item.minecraft.hopper_minecart": "Trichterlore",
  "item.minecraft.horse_spawn_egg": "Pferde-Spawn-Ei",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gastwirts-Rüstungsbesatz",
  "item.minecraft.howl_pottery_shard": "Geheul-Töpferscherbe",
  "item.minecraft.howl_pottery_sherd": "Geheul-Töpferscherbe",
  "item.minecraft.husk_spawn_egg": "Wüstenzombie-Spawn-Ei",
  "item.minecraft.ink_sac": "Tintenbeutel",
  "item.minecraft.iron_axe": "Eisenaxt",
  "item.minecraft.iron_boots": "Eisenstiefel",
  "item.minecraft.iron_chestplate": "Eisenharnisch",
  "item.minecraft.iron_golem_spawn_egg": "Eisengolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Eisenhelm",
  "item.minecraft.iron_hoe": "Eisenhacke",
  "item.minecraft.iron_horse_armor": "Eiserner Rossharnisch",
  "item.minecraft.iron_ingot": "Eisenbarren",
  "item.minecraft.iron_leggings": "Eisenbeinschutz",
  "item.minecraft.iron_nautilus_armor": "Eiserner Nautiluspanzer",
  "item.minecraft.iron_nugget": "Eisenklumpen",
  "item.minecraft.iron_pickaxe": "Eisenspitzhacke",
  "item.minecraft.iron_shovel": "Eisenschaufel",
  "item.minecraft.iron_spear": "Eisenspeer",
  "item.minecraft.iron_sword": "Eisenschwert",
  "item.minecraft.item_frame": "Rahmen",
  "item.minecraft.jungle_boat": "Tropenholzboot",
  "item.minecraft.jungle_chest_boat": "Tropenholztruhenboot",
  "item.minecraft.knowledge_book": "Buch des Wissens",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Lavaeimer",
  "item.minecraft.lead": "Leine",
  "item.minecraft.leather": "Leder",
  "item.minecraft.leather_boots": "Lederstiefel",
  "item.minecraft.leather_chestplate": "Lederjacke",
  "item.minecraft.leather_helmet": "Lederkappe",
  "item.minecraft.leather_horse_armor": "Lederner Rossharnisch",
  "item.minecraft.leather_leggings": "Lederhose",
  "item.minecraft.light_blue_bundle": "Hellblaues Bündel",
  "item.minecraft.light_blue_dye": "Hellblauer Farbstoff",
  "item.minecraft.light_blue_harness": "Hellblaues Geschirr",
  "item.minecraft.light_gray_bundle": "Hellgraues Bündel",
  "item.minecraft.light_gray_dye": "Hellgrauer Farbstoff",
  "item.minecraft.light_gray_harness": "Hellgraues Geschirr",
  "item.minecraft.lime_bundle": "Hellgrünes Bündel",
  "item.minecraft.lime_dye": "Hellgrüner Farbstoff",
  "item.minecraft.lime_harness": "Hellgrünes Geschirr",
  "item.minecraft.lingering_potion": "Verweiltrank",
  "item.minecraft.lingering_potion.effect.awkward": "Seltsamer Verweiltrank",
  "item.minecraft.lingering_potion.effect.empty": "Nicht braubarer Verweiltrank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Verweiltrank der Feuerresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Verweiltrank des Schadens",
  "item.minecraft.lingering_potion.effect.healing": "Verweiltrank der Heilung",
  "item.minecraft.lingering_potion.effect.infested": "Verweiltrank des Befalls",
  "item.minecraft.lingering_potion.effect.invisibility": "Verweiltrank der Unsichtbarkeit",
  "item.minecraft.lingering_potion.effect.leaping": "Verweiltrank der Sprungkraft",
  "item.minecraft.lingering_potion.effect.levitation": "Verweiltrank der Schwebekraft",
  "item.minecraft.lingering_potion.effect.luck": "Verweiltrank des Glücks",
  "item.minecraft.lingering_potion.effect.mundane": "Gewöhnlicher Verweiltrank",
  "item.minecraft.lingering_potion.effect.night_vision": "Verweiltrank der Nachtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Verweiltrank des Schleimens",
  "item.minecraft.lingering_potion.effect.poison": "Verweiltrank der Vergiftung",
  "item.minecraft.lingering_potion.effect.regeneration": "Verweiltrank der Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Verweiltrank des sanften Falls",
  "item.minecraft.lingering_potion.effect.slowness": "Verweiltrank der Langsamkeit",
  "item.minecraft.lingering_potion.effect.strength": "Verweiltrank der Stärke",
  "item.minecraft.lingering_potion.effect.swiftness": "Verweiltrank der Schnelligkeit",
  "item.minecraft.lingering_potion.effect.thick": "Dickflüssiger Verweiltrank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Verweiltrank des Schildkrötenmeisters",
  "item.minecraft.lingering_potion.effect.water": "Verweilende Wasserflasche",
  "item.minecraft.lingering_potion.effect.water_breathing": "Verweiltrank der Unterwasseratmung",
  "item.minecraft.lingering_potion.effect.weakness": "Verweiltrank der Schwäche",
  "item.minecraft.lingering_potion.effect.weaving": "Verweiltrank des Webens",
  "item.minecraft.lingering_potion.effect.wind_charged": "Verweiltrank der Windladung",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ei",
  "item.minecraft.lodestone_compass": "Leitstein-Kompass",
  "item.minecraft.mace": "Streitkolben",
  "item.minecraft.magenta_bundle": "Magenta Bündel",
  "item.minecraft.magenta_dye": "Magenta Farbstoff",
  "item.minecraft.magenta_harness": "Magenta Geschirr",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmawürfel-Spawn-Ei",
  "item.minecraft.mangrove_boat": "Mangrovenholzboot",
  "item.minecraft.mangrove_chest_boat": "Mangrovenholztruhenboot",
  "item.minecraft.map": "Leere Karte",
  "item.minecraft.melon_seeds": "Melonenkerne",
  "item.minecraft.melon_slice": "Melonenscheibe",
  "item.minecraft.milk_bucket": "Milcheimer",
  "item.minecraft.minecart": "Lore",
  "item.minecraft.miner_pottery_shard": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.miner_pottery_sherd": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.mojang_banner_pattern": "Bannervorlage",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Mojang-Logo-Bannervorlage",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ei",
  "item.minecraft.mourner_pottery_shard": "Wimmerer-Töpferscherbe",
  "item.minecraft.mourner_pottery_sherd": "Wimmerer-Töpferscherbe",
  "item.minecraft.mule_spawn_egg": "Maultier-Spawn-Ei",
  "item.minecraft.mushroom_stew": "Pilzsuppe",
  "item.minecraft.music_disc_11": "Schallplatte",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schallplatte",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schallplatte",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schallplatte",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schallplatte",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schallplatte",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schallplatte",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schallplatte",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Spieluhr)",
  "item.minecraft.music_disc_far": "Schallplatte",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplatte",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schallplatte",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schallplatte",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schallplatte",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schallplatte",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schallplatte",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schallplatte",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schallplatte",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schallplatte",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schallplatte",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schallplatte",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schallplatte",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rohes Hammelfleisch",
  "item.minecraft.name_tag": "Namensschild",
  "item.minecraft.nautilus_shell": "Nautilusschale",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ei",
  "item.minecraft.nether_brick": "Netherziegel",
  "item.minecraft.nether_star": "Netherstern",
  "item.minecraft.nether_wart": "Netherwarze",
  "item.minecraft.netherite_axe": "Netheritaxt",
  "item.minecraft.netherite_boots": "Netheritstiefel",
  "item.minecraft.netherite_chestplate": "Netheritharnisch",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netherithacke",
  "item.minecraft.netherite_horse_armor": "Netheritener Rossharnisch",
  "item.minecraft.netherite_ingot": "Netheritbarren",
  "item.minecraft.netherite_leggings": "Netheritbeinschutz",
  "item.minecraft.netherite_nautilus_armor": "Netheritener Nautiluspanzer",
  "item.minecraft.netherite_pickaxe": "Netheritspitzhacke",
  "item.minecraft.netherite_scrap": "Netheritplatten",
  "item.minecraft.netherite_shovel": "Netheritschaufel",
  "item.minecraft.netherite_spear": "Netheritspeer",
  "item.minecraft.netherite_sword": "Netheritschwert",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedevorlage",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritaufwertung",
  "item.minecraft.oak_boat": "Eichenholzboot",
  "item.minecraft.oak_chest_boat": "Eichenholztruhenboot",
  "item.minecraft.ocelot_spawn_egg": "Ozelot-Spawn-Ei",
  "item.minecraft.ominous_bottle": "Unheilvolle Flasche",
  "item.minecraft.ominous_trial_key": "Unheilvoller Prüfungsschlüssel",
  "item.minecraft.orange_bundle": "Oranges Bündel",
  "item.minecraft.orange_dye": "Oranger Farbstoff",
  "item.minecraft.orange_harness": "Oranges Geschirr",
  "item.minecraft.painting": "Gemälde",
  "item.minecraft.pale_oak_boat": "Blasseichenholzboot",
  "item.minecraft.pale_oak_chest_boat": "Blasseichenholztruhenboot",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ei",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Vertrockneten-Spawn-Ei",
  "item.minecraft.parrot_spawn_egg": "Papageien-Spawn-Ei",
  "item.minecraft.phantom_membrane": "Phantomhaut",
  "item.minecraft.phantom_spawn_egg": "Phantom-Spawn-Ei",
  "item.minecraft.pig_spawn_egg": "Schweine-Spawn-Ei",
  "item.minecraft.piglin_banner_pattern": "Bannervorlage",
  "item.minecraft.piglin_banner_pattern.desc": "Schnauze",
  "item.minecraft.piglin_banner_pattern.new": "Schnauzen-Bannervorlage",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbaren-Spawn-Ei",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ei",
  "item.minecraft.pillager_spawn_egg": "Plünderer-Spawn-Ei",
  "item.minecraft.pink_bundle": "Rosa Bündel",
  "item.minecraft.pink_dye": "Rosa Farbstoff",
  "item.minecraft.pink_harness": "Rosa Geschirr",
  "item.minecraft.pitcher_plant": "Kannenpflanze",
  "item.minecraft.pitcher_pod": "Kannenpflanzenkapsel",
  "item.minecraft.plenty_pottery_shard": "Reichtums-Töpferscherbe",
  "item.minecraft.plenty_pottery_sherd": "Reichtums-Töpferscherbe",
  "item.minecraft.poisonous_potato": "Giftige Kartoffel",
  "item.minecraft.polar_bear_spawn_egg": "Eisbären-Spawn-Ei",
  "item.minecraft.popped_chorus_fruit": "Geplatzte Chorusfrucht",
  "item.minecraft.porkchop": "Rohes Schweinefleisch",
  "item.minecraft.potato": "Kartoffel",
  "item.minecraft.potion": "Trank",
  "item.minecraft.potion.effect.awkward": "Seltsamer Trank",
  "item.minecraft.potion.effect.empty": "Nicht braubarer Trank",
  "item.minecraft.potion.effect.fire_resistance": "Trank der Feuerresistenz",
  "item.minecraft.potion.effect.harming": "Trank des Schadens",
  "item.minecraft.potion.effect.healing": "Trank der Heilung",
  "item.minecraft.potion.effect.infested": "Trank des Befalls",
  "item.minecraft.potion.effect.invisibility": "Trank der Unsichtbarkeit",
  "item.minecraft.potion.effect.leaping": "Trank der Sprungkraft",
  "item.minecraft.potion.effect.levitation": "Trank der Schwebekraft",
  "item.minecraft.potion.effect.luck": "Trank des Glücks",
  "item.minecraft.potion.effect.mundane": "Gewöhnlicher Trank",
  "item.minecraft.potion.effect.night_vision": "Trank der Nachtsicht",
  "item.minecraft.potion.effect.oozing": "Trank des Schleimens",
  "item.minecraft.potion.effect.poison": "Trank der Vergiftung",
  "item.minecraft.potion.effect.regeneration": "Trank der Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Trank des sanften Falls",
  "item.minecraft.potion.effect.slowness": "Trank der Langsamkeit",
  "item.minecraft.potion.effect.strength": "Trank der Stärke",
  "item.minecraft.potion.effect.swiftness": "Trank der Schnelligkeit",
  "item.minecraft.potion.effect.thick": "Dickflüssiger Trank",
  "item.minecraft.potion.effect.turtle_master": "Trank des Schildkrötenmeisters",
  "item.minecraft.potion.effect.water": "Wasserflasche",
  "item.minecraft.potion.effect.water_breathing": "Trank der Unterwasseratmung",
  "item.minecraft.potion.effect.weakness": "Trank der Schwäche",
  "item.minecraft.potion.effect.weaving": "Trank des Webens",
  "item.minecraft.potion.effect.wind_charged": "Trank der Windladung",
  "item.minecraft.pottery_shard_archer": "Schützen-Töpferscherbe",
  "item.minecraft.pottery_shard_arms_up": "Gebärden-Töpferscherbe",
  "item.minecraft.pottery_shard_prize": "Juwelen-Töpferscherbe",
  "item.minecraft.pottery_shard_skull": "Totenkopf-Töpferscherbe",
  "item.minecraft.powder_snow_bucket": "Pulverschneeeimer",
  "item.minecraft.prismarine_crystals": "Prismarinkristalle",
  "item.minecraft.prismarine_shard": "Prismarinscherbe",
  "item.minecraft.prize_pottery_shard": "Juwelen-Töpferscherbe",
  "item.minecraft.prize_pottery_sherd": "Juwelen-Töpferscherbe",
  "item.minecraft.pufferfish": "Kugelfisch",
  "item.minecraft.pufferfish_bucket": "Kugelfischeimer",
  "item.minecraft.pufferfish_spawn_egg": "Kugelfisch-Spawn-Ei",
  "item.minecraft.pumpkin_pie": "Kürbiskuchen",
  "item.minecraft.pumpkin_seeds": "Kürbiskerne",
  "item.minecraft.purple_bundle": "Violettes Bündel",
  "item.minecraft.purple_dye": "Violetter Farbstoff",
  "item.minecraft.purple_harness": "Violettes Geschirr",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Rohes Kaninchen",
  "item.minecraft.rabbit_foot": "Hasenpfote",
  "item.minecraft.rabbit_hide": "Kaninchenfell",
  "item.minecraft.rabbit_spawn_egg": "Kaninchen-Spawn-Ei",
  "item.minecraft.rabbit_stew": "Kaninchenragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Aufzieher-Rüstungsbesatz",
  "item.minecraft.ravager_spawn_egg": "Verwüster-Spawn-Ei",
  "item.minecraft.raw_copper": "Rohkupfer",
  "item.minecraft.raw_gold": "Rohgold",
  "item.minecraft.raw_iron": "Roheisen",
  "item.minecraft.recovery_compass": "Bergungskompass",
  "item.minecraft.red_bundle": "Rotes Bündel",
  "item.minecraft.red_dye": "Roter Farbstoff",
  "item.minecraft.red_harness": "Rotes Geschirr",
  "item.minecraft.redstone": "Redstone-Staub",
  "item.minecraft.resin_brick": "Harzziegel",
  "item.minecraft.resin_clump": "Harzklumpen",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippen-Rüstungsbesatz",
  "item.minecraft.rotten_flesh": "Verrottetes Fleisch",
  "item.minecraft.saddle": "Sattel",
  "item.minecraft.salmon": "Roher Lachs",
  "item.minecraft.salmon_bucket": "Lachseimer",
  "item.minecraft.salmon_spawn_egg": "Lachs-Spawn-Ei",
  "item.minecraft.scrape_pottery_sherd": "Abschabe-Töpferscherbe",
  "item.minecraft.scute": "Hornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wachen-Rüstungsbesatz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Gestalter-Rüstungsbesatz",
  "item.minecraft.sheaf_pottery_shard": "Garben-Töpferscherbe",
  "item.minecraft.sheaf_pottery_sherd": "Garben-Töpferscherbe",
  "item.minecraft.shears": "Schere",
  "item.minecraft.sheep_spawn_egg": "Schafs-Spawn-Ei",
  "item.minecraft.shelter_pottery_shard": "Zufluchts-Töpferscherbe",
  "item.minecraft.shelter_pottery_sherd": "Zufluchts-Töpferscherbe",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Schwarzer Schild",
  "item.minecraft.shield.blue": "Blauer Schild",
  "item.minecraft.shield.brown": "Brauner Schild",
  "item.minecraft.shield.cyan": "Türkiser Schild",
  "item.minecraft.shield.gray": "Grauer Schild",
  "item.minecraft.shield.green": "Grüner Schild",
  "item.minecraft.shield.light_blue": "Hellblauer Schild",
  "item.minecraft.shield.light_gray": "Hellgrauer Schild",
  "item.minecraft.shield.lime": "Hellgrüner Schild",
  "item.minecraft.shield.magenta": "Magenta Schild",
  "item.minecraft.shield.orange": "Oranger Schild",
  "item.minecraft.shield.pink": "Rosa Schild",
  "item.minecraft.shield.purple": "Violetter Schild",
  "item.minecraft.shield.red": "Roter Schild",
  "item.minecraft.shield.white": "Weißer Schild",
  "item.minecraft.shield.yellow": "Gelber Schild",
  "item.minecraft.shulker_shell": "Shulker-Schale",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ei",
  "item.minecraft.sign": "Schild",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stille-Rüstungsbesatz",
  "item.minecraft.silverfish_spawn_egg": "Silberfischchen-Spawn-Ei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettpferde-Spawn-Ei",
  "item.minecraft.skeleton_spawn_egg": "Skelett-Spawn-Ei",
  "item.minecraft.skull_banner_pattern": "Bannervorlage",
  "item.minecraft.skull_banner_pattern.desc": "Schädel",
  "item.minecraft.skull_banner_pattern.new": "Schädel-Bannervorlage",
  "item.minecraft.skull_pottery_shard": "Totenkopf-Töpferscherbe",
  "item.minecraft.skull_pottery_sherd": "Totenkopf-Töpferscherbe",
  "item.minecraft.slime_ball": "Schleimball",
  "item.minecraft.slime_spawn_egg": "Schleim-Spawn-Ei",
  "item.minecraft.smithing_template": "Schmiedevorlage",
  "item.minecraft.smithing_template.applies_to": "Anwendbar auf:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Barren oder Kristall hinzufügen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsteil hinzufügen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barren & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Werkstoffe:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritbarren hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantausrüstung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstungsteil, Werkzeug oder Schwert aus Diamant hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritbarren",
  "item.minecraft.smithing_template.upgrade": "Aufwertung: ",
  "item.minecraft.sniffer_spawn_egg": "Schnüffler-Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Schnaub-Töpferscherbe",
  "item.minecraft.snort_pottery_sherd": "Schnaub-Töpferscherbe",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauzen-Rüstungsbesatz",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem-Spawn-Ei",
  "item.minecraft.snowball": "Schneeball",
  "item.minecraft.spectral_arrow": "Spektralpfeil",
  "item.minecraft.spider_eye": "Spinnenauge",
  "item.minecraft.spider_spawn_egg": "Spinnen-Spawn-Ei",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitzen-Rüstungsbesatz",
  "item.minecraft.splash_potion": "Wurftrank",
  "item.minecraft.splash_potion.effect.awkward": "Seltsamer Wurftrank",
  "item.minecraft.splash_potion.effect.empty": "Nicht braubarer Wurftrank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wurftrank der Feuerresistenz",
  "item.minecraft.splash_potion.effect.harming": "Wurftrank des Schadens",
  "item.minecraft.splash_potion.effect.healing": "Wurftrank der Heilung",
  "item.minecraft.splash_potion.effect.infested": "Wurftrank des Befalls",
  "item.minecraft.splash_potion.effect.invisibility": "Wurftrank der Unsichtbarkeit",
  "item.minecraft.splash_potion.effect.leaping": "Wurftrank der Sprungkraft",
  "item.minecraft.splash_potion.effect.levitation": "Wurftrank der Schwebekraft",
  "item.minecraft.splash_potion.effect.luck": "Wurftrank des Glücks",
  "item.minecraft.splash_potion.effect.mundane": "Gewöhnlicher Wurftrank",
  "item.minecraft.splash_potion.effect.night_vision": "Wurftrank der Nachtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Wurftrank des Schleimens",
  "item.minecraft.splash_potion.effect.poison": "Wurftrank der Vergiftung",
  "item.minecraft.splash_potion.effect.regeneration": "Wurftrank der Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wurftrank des sanften Falls",
  "item.minecraft.splash_potion.effect.slowness": "Wurftrank der Langsamkeit",
  "item.minecraft.splash_potion.effect.strength": "Wurftrank der Stärke",
  "item.minecraft.splash_potion.effect.swiftness": "Wurftrank der Schnelligkeit",
  "item.minecraft.splash_potion.effect.thick": "Dickflüssiger Wurftrank",
  "item.minecraft.splash_potion.effect.turtle_master": "Wurftrank des Schildkrötenmeisters",
  "item.minecraft.splash_potion.effect.water": "Werfbare Wasserflasche",
  "item.minecraft.splash_potion.effect.water_breathing": "Wurftrank der Unterwasseratmung",
  "item.minecraft.splash_potion.effect.weakness": "Wurftrank der Schwäche",
  "item.minecraft.splash_potion.effect.weaving": "Wurftrank des Webens",
  "item.minecraft.splash_potion.effect.wind_charged": "Wurftrank der Windladung",
  "item.minecraft.spruce_boat": "Fichtenholzboot",
  "item.minecraft.spruce_chest_boat": "Fichtenholztruhenboot",
  "item.minecraft.spyglass": "Fernrohr",
  "item.minecraft.squid_spawn_egg": "Tintenfisch-Spawn-Ei",
  "item.minecraft.stick": "Stock",
  "item.minecraft.stone_axe": "Steinaxt",
  "item.minecraft.stone_hoe": "Steinhacke",
  "item.minecraft.stone_pickaxe": "Steinspitzhacke",
  "item.minecraft.stone_shovel": "Steinschaufel",
  "item.minecraft.stone_spear": "Steinspeer",
  "item.minecraft.stone_sword": "Steinschwert",
  "item.minecraft.stray_spawn_egg": "Eiswanderer-Spawn-Ei",
  "item.minecraft.strider_spawn_egg": "Schreiter-Spawn-Ei",
  "item.minecraft.string": "Faden",
  "item.minecraft.sugar": "Zucker",
  "item.minecraft.suspicious_stew": "Seltsame Suppe",
  "item.minecraft.sweet_berries": "Süßbeeren",
  "item.minecraft.tadpole_bucket": "Kaulquappeneimer",
  "item.minecraft.tadpole_spawn_egg": "Kaulquappen-Spawn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeiten-Rüstungsbesatz",
  "item.minecraft.tipped_arrow": "Getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.awkward": "Getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.empty": "Nicht herstellbarer getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pfeil der Feuerresistenz",
  "item.minecraft.tipped_arrow.effect.harming": "Pfeil des Schadens",
  "item.minecraft.tipped_arrow.effect.healing": "Pfeil der Heilung",
  "item.minecraft.tipped_arrow.effect.infested": "Pfeil des Befalls",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pfeil der Unsichtbarkeit",
  "item.minecraft.tipped_arrow.effect.leaping": "Pfeil der Sprungkraft",
  "item.minecraft.tipped_arrow.effect.levitation": "Pfeil der Schwebekraft",
  "item.minecraft.tipped_arrow.effect.luck": "Pfeil des Glücks",
  "item.minecraft.tipped_arrow.effect.mundane": "Getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pfeil der Nachtsicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfeil des Schleimens",
  "item.minecraft.tipped_arrow.effect.poison": "Pfeil der Vergiftung",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pfeil der Regeneration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfeil des sanften Falls",
  "item.minecraft.tipped_arrow.effect.slowness": "Pfeil der Langsamkeit",
  "item.minecraft.tipped_arrow.effect.strength": "Pfeil der Stärke",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pfeil der Schnelligkeit",
  "item.minecraft.tipped_arrow.effect.thick": "Getränkter Pfeil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfeil des Schildkrötenmeisters",
  "item.minecraft.tipped_arrow.effect.water": "Nasser Pfeil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pfeil der Unterwasseratmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Pfeil der Schwäche",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfeil des Webens",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfeil der Windladung",
  "item.minecraft.tnt_minecart": "TNT-Lore",
  "item.minecraft.torchflower_seeds": "Fackelliliensamen",
  "item.minecraft.totem_of_undying": "Totem der Unsterblichkeit",
  "item.minecraft.trader_llama_spawn_egg": "Händlerlama-Spawn-Ei",
  "item.minecraft.trial_key": "Prüfungsschlüssel",
  "item.minecraft.trident": "Dreizack",
  "item.minecraft.tropical_fish": "Tropenfisch",
  "item.minecraft.tropical_fish_bucket": "Tropenfischeimer",
  "item.minecraft.tropical_fish_spawn_egg": "Tropenfisch-Spawn-Ei",
  "item.minecraft.turtle_helmet": "Schildkrötenpanzer",
  "item.minecraft.turtle_scute": "Schildkröten-Hornschild",
  "item.minecraft.turtle_spawn_egg": "Schildkröten-Spawn-Ei",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plagegeister-Rüstungsbesatz",
  "item.minecraft.vex_spawn_egg": "Plagegeister-Spawn-Ei",
  "item.minecraft.villager_spawn_egg": "Dorfbewohner-Spawn-Ei",
  "item.minecraft.vindicator_spawn_egg": "Diener-Spawn-Ei",
  "item.minecraft.wandering_trader_spawn_egg": "Fahrender-Händler-Spawn-Ei",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Warthof-Rüstungsbesatz",
  "item.minecraft.warden_spawn_egg": "Wärter-Spawn-Ei",
  "item.minecraft.warped_fungus_on_a_stick": "Wirrpilzrute",
  "item.minecraft.water_bucket": "Wassereimer",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wegfinder-Rüstungsbesatz",
  "item.minecraft.wheat": "Weizen",
  "item.minecraft.wheat_seeds": "Weizenkörner",
  "item.minecraft.white_bundle": "Weißes Bündel",
  "item.minecraft.white_dye": "Weißer Farbstoff",
  "item.minecraft.white_harness": "Weißes Geschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wildnis-Rüstungsbesatz",
  "item.minecraft.wind_charge": "Windkugel",
  "item.minecraft.witch_spawn_egg": "Hexen-Spawn-Ei",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither-Skelett-Spawn-Ei",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Ei",
  "item.minecraft.wolf_armor": "Wolfspanzer",
  "item.minecraft.wolf_spawn_egg": "Wolfs-Spawn-Ei",
  "item.minecraft.wooden_axe": "Holzaxt",
  "item.minecraft.wooden_hoe": "Holzhacke",
  "item.minecraft.wooden_pickaxe": "Holzspitzhacke",
  "item.minecraft.wooden_shovel": "Holzschaufel",
  "item.minecraft.wooden_spear": "Holzspeer",
  "item.minecraft.wooden_sword": "Holzschwert",
  "item.minecraft.writable_book": "Buch und Feder",
  "item.minecraft.written_book": "Beschriebenes Buch",
  "item.minecraft.yellow_bundle": "Gelbes Bündel",
  "item.minecraft.yellow_dye": "Gelber Farbstoff",
  "item.minecraft.yellow_harness": "Gelbes Geschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepferde-Spawn-Ei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilus-Spawn-Ei",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Ei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorfbewohner-Spawn-Ei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizierter-Piglin-Spawn-Ei"
}
export const de_de = items; 
